<template>
  <div class="container my-4">
    <b-alert
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      fade
      :show="dismissCountDown"
      :variant="errorMessage.color"
      @dismissed="dismissed"
    >
      {{ errorMessage.text }}
    </b-alert>
    <b-modal
      v-model="showMatriculaDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <b-row>
        <b-col>
          <b-form-group class="mb-0">
            <div class="mb-4"><b>Dados da Matrícula</b></div>

            <b-row>
              <b-col
                ><small class="form-text text-muted mt-3 mb-1"
                  >Nº da Matrícula</small
                >
                <b-form-input
                  size="sm"
                  v-model="proposal.matricula"
                  placeholder="Digite o nº da Matrícula"
                ></b-form-input
              ></b-col>
              <b-col
                ><small class="form-text text-muted mt-3 mb-1"
                  >Data da Matrícula</small
                >
                <b-form-datepicker
                  class="mb-2"
                  size="sm"
                  placeholder="Data de emissão"
                  locale="pt-BR"
                  today-button
                  reset-button
                  close-button
                  :date-format-options="{
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  }"
                  v-model="proposal.issueDate"
                ></b-form-datepicker
              ></b-col>
            </b-row>
          </b-form-group>

          <small class="form-text text-muted mt-3 mb-1"
            >Localização do Imóvel</small
          >
          <!-- <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.propertyLocation"
                  ></b-form-input>
          <vue-google-autocomplete
            ref="address"
            id="map"
            classname="form-control form-control-sm"
            placeholder="Localização do Imóvel"
            country="br"
            v-on:placechanged="getAddressData"
            v-model="locationData"
            types=""
            size="sm"
            disabled
          >
          </vue-google-autocomplete> -->
          <small class="form-text text-muted mt-3 mb-1"
            >Imóvel possui Interveniente Quitante?</small
          >

          <b-form-checkbox switch size="sm" v-model="proposal.propertyIQ"
            >Sim</b-form-checkbox
          >
          <div v-if="proposal.propertyIQ">
            <small class="form-text text-muted mt-3 mb-1"
              >De qual instituição bancária?</small
            >
            <b-form-select
              v-model="bankingnDischargerIntervener"
              :options="bankingnDischargerIntervenerOptions"
              :select-size="4"
            ></b-form-select>
            <small class="form-text text-muted mt-1 mb-1"
              >Should show info text...</small
            >
          </div>
        </b-col>
        <b-col style="border-left: 1px solid #ccc">
          <div class="mb-4"><b>Verificações necessária</b></div>
          <div v-for="(list, index) in pendingList" :key="index">
            <div
              class="
                userListItem
                d-flex
                justify-content-between
                align-items-center
              "
            >
              <div class="userListItemLabel">{{ list.item }}</div>
              <b-form-checkbox v-model="list.show"></b-form-checkbox>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-model="showPendingDialog"
      size="sm"
      hide-header
      hide-footer
      centered
    >
      <div v-for="(list, index) in pendingList" :key="index">
        <div
          class="userListItem d-flex justify-content-between align-items-center"
        >
          <div class="userListItemLabel">{{ list.item }}</div>
          <b-form-checkbox v-model="list.show"></b-form-checkbox>
        </div>
      </div>
    </b-modal>

    <!-- show BanckBranch and Controls Dialog -->
    <b-modal
      v-model="showBankBranchDialog"
      size="sm"
      hide-header
      hide-footer
      centered
    >
    <div class="mb-4"><b>Agência e Controles</b></div>

    <b-row class="d-flex align-items-center">
                  <b-col>
                    <b-form-select
                      ref="bankBranch"
                      v-model="proposal.bankBranch"
                      :options="bankBranches"
                      class="mb-2"
                      size="sm"
                    ></b-form-select>
                    </b-col>
                    </b-row>
    <b-row class="mt-2">
      <b-col class="d-flex justify-content-between align-items-center">

                    <b-form-checkbox switch v-model="proposal.actived" size="sm"
                      >Ativa</b-form-checkbox
                    >
                    <b-form-checkbox
                      switch
                      v-model="proposal.expected"
                      size="sm"
                      >Prevista</b-form-checkbox
                    >
                    <i
                      class="fa fa-trash-alt mb-1"
                      v-b-tooltip.hover.top
                      :title="'Excluir'"
                      @click="confirmDeleteProposal(proposal)"
                    ></i>

                    <!--<b-form-checkbox switch v-model="proposal.fgts" size="sm"
                      >Utiliza FGTS?</b-form-checkbox
                    >
                    
                    <b-form-checkbox
                      switch
                      v-model="proposal.notaryExpenses"
                      size="sm"
                      >Incluir despesas cartorárias</b-form-checkbox
                    >
                    <b-form-checkbox switch v-model="proposal.comite" size="sm"
                      >Comitê</b-form-checkbox
                    >-->
                    
                  </b-col>
                </b-row>
    </b-modal>
    
    <!-- show riskAssessment Dialog -->
    <b-modal
      v-model="showriskAssessmentDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
    <ControlOfTheRiskAssessmentFlow></ControlOfTheRiskAssessmentFlow>

    </b-modal>

    <!-- show Fgts Dialog -->
    <b-modal
      v-model="showPendingFgtsDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <ControlOfTheFgtsFlow></ControlOfTheFgtsFlow>
    </b-modal>

    <!-- show Engineering Dialog -->
    <b-modal
      v-model="showPendingEngineeringDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <ControlOfTheEngineeringFlow></ControlOfTheEngineeringFlow>
    </b-modal>

    <!-- show Forms Dialog -->
    <b-modal
      v-model="showPendingFormsDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <ControlOfTheFormsFlow></ControlOfTheFormsFlow>
    </b-modal>

    <!-- show Dossiê Dialog -->
    <b-modal
      v-model="showPendingDossieDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
    <ControlOfTheDossieFlow></ControlOfTheDossieFlow>
    </b-modal>

    <!-- show Comitê Dialog -->
    <b-modal
      v-model="showComiteDialog"
      size="sm"
      hide-header
      hide-footer
      centered
    >
    <div
                    v-if="proposal.comite"
                    class="d-flex align-items-center justify-content-between"
                  >
                    <b-form-checkbox
                      class="py-1"
                      v-model="proposal.comiteChecked"
                      :indeterminate.sync="proposal.comiteIndeterminate"
                    >
                      <span v-if="proposal.comiteIndeterminate"
                        >Comitê em processo</span
                      >
                      <span v-else-if="!proposal.comiteChecked"
                        >Solicitar comitê</span
                      >
                      <span v-else>Comitê liberado</span>
                    </b-form-checkbox>
                    <i
                      v-if="
                        !proposal.comiteChecked && !proposal.comiteIndeterminate
                      "
                      @click="
                        proposal.comiteIndeterminate =
                          !proposal.comiteIndeterminate
                      "
                      class="alertIcon mr-3 pointer d-flex align-items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-send-slash"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                        />
                        <path
                          d="M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                        />
                      </svg>
                    </i>
                  </div>
    </b-modal>

    <!-- show Contract Dialog -->
    <b-modal
      v-model="showPendingContractDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
    <ControlOfTheContractFlow></ControlOfTheContractFlow>
    </b-modal>
    

    <!-- show Siopi Dialog -->
    <b-modal
      v-model="showSiopiDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
    <ControlOfTheSiopiFlow></ControlOfTheSiopiFlow>
    </b-modal>


    <!-- show Bidder Dialog -->
    <b-modal
      v-model="showBidderDialog"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <div v-for="(list, index) in bidderList" :key="index">
        <div
          class="userListItem d-flex justify-content-between align-items-center"
        >
          <div class="userListItemLabel">{{ list.item }}</div>
          <b-form-checkbox v-model="list.notShow"></b-form-checkbox>
        </div>
      </div>
    </b-modal>

    <!-- show Participant Dialog -->
    <b-modal
      :id="`participantModal-${selectedParticipant}`"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <div v-if="proposal.participants && proposal.participants.length">
        <div
          v-for="(list, partIndex) in proposal.participants[selectedParticipant]
            .participantList"
          :key="partIndex"
        >
          <div
            class="
              userListItem
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div class="userListItemLabel">{{ list.item }}</div>
            <b-form-checkbox v-model="list.notShow"></b-form-checkbox>
          </div>
        </div>
      </div>
    </b-modal>

    <div>
      <form @submit.prevent="handleUpdateProposal(proposal)" class="mt-4">
        <b-row class="d-flex justify-content-between align-items-center mb-4">
          <b-col lg="auto">
            <div>
              <i
                v-if="
                  proposal.participants && proposal.participants.length <= 0
                "
                class="fas fa-user mr-1"
              ></i>
              <i
                v-else-if="
                  proposal.participants && proposal.participants.length == 1
                "
                v-b-tooltip.hover.rightbottom
                :title="'+ ' + proposal.participants.length"
                class="fas fa-user-friends mr-1"
              ></i>
              <i
                v-else-if="
                  proposal.participants && proposal.participants.length >= 2
                "
                v-b-tooltip.hover.rightbottom
                :title="'+ ' + proposal.participants.length"
                class="fas fa-users mr-1"
              ></i>
              {{ proposal.name }}, CPF.: {{ proposal.cpf }}
            </div>
            <div
              v-for="(participant, index ) in proposal.participants" :key="index"
            >
              <i class="fa fa-link ml-3" aria-hidden="true"></i>

              {{ participant.fullName }}, CPF.:
              {{ participant.cpf }}
            </div>
          </b-col>
          <b-col lg="auto">
            <button
              class="btn btn-outline-secondary btn-sm mr-5"
              alt="Voltar sem Salvar"
              @click="cancelEdit"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              Sair
            </button>
            <button
              type="submit"
              class="btn btn-outline-success btn-sm mr-5"
              alt="Atualizar Proposta"
            >
              Atualizar
            </button>
            <b-badge
              v-if="proposal.bankBranch == ''"
              variant="warning mr-5 p-2"
              >AGÊNCIA</b-badge
            >
            <b-badge v-else variant="primary mr-5 p-2">{{
              proposal.bankBranch
            }}</b-badge>

            <b-avatar
              v-if="sharedUsers == ''"
              variant="light"
              size="2rem"
              v-b-tooltip.hover.top
              :title="'Vincule o usuário que originou a proposta'"
            ></b-avatar>
            <b-avatar
              v-else
              variant="primary"
              size="2rem"
              v-b-tooltip.hover.top
              :title="sharedUsers[0]"
            ></b-avatar>
            <i
              class="fas fa-share-alt"
              v-b-tooltip.hover.top
              :title="'Incluir compartilhamento'"
              @click="showUserList = !showUserList"
            ></i>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="userListWrapper">
              <div v-if="showUserList" class="userList bg-light border">
                <div
                  class="
                    userListHead
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <div>Select users</div>
                  <div class="searchWrapper">
                    <div class="input-group">
                      <b-form-input
                        placeholder="Pesquisar usuário"
                        class="search"
                        size="sm"
                        type="search"
                        v-model="searchUser"
                      ></b-form-input>
                      <span class="bar"></span>
                    </div>
                  </div>
                </div>
                <div v-if="usersList && usersList.length" class="userListBody">
                  <div v-for="(user, index) in usersList" :key="index">
                    <div
                      class="
                        userListItem
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      <div class="userListItemLabel">
                        {{ user.name }}
                      </div>
                      <b-form-checkbox
                        v-model="user.shared"
                        @change="handleAddUsers(user.uid, $event)"
                      ></b-form-checkbox>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center py-4">No user found</div>
                <div class="userListFooter d-flex justify-content-between p-3">
                  <b-button
                    variant="danger"
                    size="sm"
                    class=""
                    @click="handleCloseList"
                    >Close</b-button
                  >
                  <b-button
                    variant="primary"
                    size="sm"
                    class=""
                    @click="handleShareProposal"
                  >
                    <span v-if="!isLoading">Share</span>
                    <b-spinner
                      v-else
                      style="width: 1rem; height: 1rem"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <b-alert
              show
              v-if="proposal.propertyIQ && proposal.operationModality == 'CRF'"
              variant="danger"
              >Proposta não atendida pelo CCA. MO43.082 => 3.2.5.1.1 As
              operações de renovação do Crédito Real Fácil CAIXA ou concessão do
              Crédito Real Fácil com liquidação de um CIP, Aporte CAIXA, CDC ou
              financiamento habitacional com recursos SBPE não estão disponíveis
              para contratação pelo correspondentes bancários.</b-alert
            >
            <b-alert
              show
              v-if="
                (proposal.steps.engineering.actived == true &&
                  proposal.matricula == '') ||
                proposal.propertyLocation.route == ''
              "
              variant="info"
              dismissible
              >Informe os dados da matrícula e/ou localização do
              imóvel.</b-alert
            >
            <b-alert :variant="showAlertMatriculaVariant" dismissible v-model="showAlertMatricula"
              >{{showAlertMatriculaMessage}}</b-alert
            >
            <b-alert show v-if="sharedUsers == ''" variant="warning" dismissible
              >Vincule o usuário da proposta que originou a proposta.</b-alert
            >
            <b-alert
              show
              v-if="proposal.propertyIQ && !proposal.verifiedSD"
              variant="info"
              dismissible
              >Necessário verificar saldo devedor do contrato anterior.</b-alert
            >
          </b-col>
        </b-row>
        <div>
          <b-tabs content-class="">
            <b-tab title="Resumo" class="mt-3">
              <b-row class=""><!--d-flex-->
                <b-col cols="9">
                  <b-card header-bg-variant="light"  border-variant="light" header="Visão Geral" style="max-height: 25rem;">
                  <b-card-text>
                    <!--<small class="form-text mb-1"><b>Imóvel {{ proposal.propertyType }}
                      {{ proposal.propertyCategory }} no valor de </b>
                      <span>{{ proposal.propertyValue | currency }}</span> 
                    </small>
                    <b-col>
                      {{ proposal.operationModality }} /
                      {{ proposal.amortizationSystem }} / {{ proposal.indexer }} /
                      {{ proposal.intendedFinancingValue | currency }} /
                      {{ proposal.period }} meses
                    </b-col>-->
                    <b-col class="my-2">
                      <small class="form-text">Modalidade | Sistema de Amortização | Indexador | Prazo </small>
                      <div class="d-flex justify-content-between align-items-center">
                        <span><b>{{ proposal.operationModality }} /
                      {{ proposal.amortizationSystem }} / {{ proposal.indexer }} /
                      {{ proposal.period }} meses <i v-if="proposal.operationModality == 'CRF'" v-b-tooltip.hover.topright title="Se renda proveniente de sócio de empresa o prazo máximo deverá ser 120 meses e o valor máximo de crédito até 50% do valor do imóvel/engenharia." class="fa fa-exclamation-triangle mr-2 text-warning" aria-hidden="true"></i></b></span>
                      <span v-if="(proposal.propertyValue > 1500000 && proposal.engineeringEvaluation == 0) || proposal.engineeringEvaluation > 1500000 || proposal.propertyType == 'Comecial' || proposal.operationModality == 'CRF' || proposal.propertyCategory == 'Terreno'"><b-badge variant="warning">SFI</b-badge></span>
                      <span v-else-if ="proposal.propertyValue > 1500000 && proposal.engineeringEvaluation <= 1500000"><b-badge variant="info"><i class="fa fa-exclamation text-warning ml-1" aria-hidden="true"></i> SFH - Reenquadrado</b-badge></span>
                      <span v-else><b-badge variant="primary">SFH</b-badge></span>
                      <span v-if="proposal.propertyType == 'Comecial' || proposal.operationModality == 'CRF'"><b-badge variant="warning">PROPOSTA COM INCIDÊNCIA DE IOF</b-badge></span>
                      </div>
                    </b-col>
                    <b-col class="my-2">
                      <small class="form-text">Imóvel {{ proposal.propertyType }}
                      {{ proposal.propertyCategory }} </small>
                      <span><b>{{ proposal.propertyValue | currency }} </b><span v-if="proposal.engineeringEvaluation != 0"><small><i><b>avaliado em </b></i></small>{{ proposal.engineeringEvaluation | currency }}
                      <i class="fa fa-check text-success ml-1" aria-hidden="true" v-if="
                        proposal.engineeringEvaluation >= proposal.propertyValue
                      "></i>
                      <i class="fa fa-exclamation text-warning ml-1" aria-hidden="true" v-else></i></span></span>
                    </b-col>
                    <b-col class="my-2">
                      <small class="form-text">Valor de Financiamento Pretendido | Quota </small>
                      <span><b>{{proposal.intendedFinancingValue | currency}}</b> | {{  proposal.intendedFinancingValue*100/proposal.propertyValue  | percent }}% 
                        <span v-if="proposal.approvedFinancingAmount != 0"><small><i>aprovado em </i></small><b>{{ proposal.approvedFinancingAmount | currency }}</b>
                      <i class="fa fa-check text-success ml-1" aria-hidden="true" v-if="
                        proposal.approvedFinancingAmount >=
                        proposal.intendedFinancingValue
                      "></i>
                      <i class="fa fa-exclamation text-warning ml-1" aria-hidden="true" v-else></i>  | {{  proposal.approvedFinancingAmount*100/proposal.propertyValue }}%
                    </span></br>
                    <span v-if="0.8*proposal.engineeringEvaluation < definesLowerValueOfTheOperation(proposal) && proposal.engineeringEvaluation != 0 && proposal.propertyType == 'Residencial'">
                      <i class="fa fa-info-circle text-danger" aria-hidden="true"></i> <small><i>Máximo de financiamento possível de </i></small><b>{{ 0.8*proposal.engineeringEvaluation | currency }}</b>
                    </span>
                    <span v-if="0.7*proposal.engineeringEvaluation < definesLowerValueOfTheOperation(proposal) && proposal.engineeringEvaluation != 0 && proposal.propertyType == 'Comecial'">
                      <i class="fa fa-info-circle text-danger" aria-hidden="true"></i> <small><i>Máximo de financiamento possível de </i></small><b>{{ 0.7*proposal.engineeringEvaluation | currency }}</b>
                    </span>
                  </span>
                    </b-col>
                    <!--<b-col class="my-2">
                      <small class="form-text"><b>Valor de Financiamento Possível</b> </small>
                      <span>{{proposal.operationValue | currency}} <small><i><b>e operação efetiva de </b></i></small></span><span v-if="proposal.operationValue != 0">{{ proposal.operationValue | currency }}</span>
                      <span v-else><i>Não definido</i></span>
                    </b-col>-->
                    <b-row class="m-0">
                      <b-col class="my-2">
                      <small class="form-text">Valor de Financiamento da Operação</small>
                      <span v-if="proposal.operationValue != 0"><b>{{proposal.operationValue | currency}}</b></span>
                      <span v-else><i><b>Não definido</b></i></span>
                      </b-col>
                    <b-col class="my-2">
                      <small class="form-text">Valor das Despesas Cartorárias</small>
                      <span v-if="proposal.notaryExpenses"><b>{{proposal.notaryExpensesAmount | currency}}</b></span>
                      <span v-else><i><b>Sem utilização</b></i></span>
                      <small v-if="proposal.notaryExpensesAmount > (0.05*proposal.operationValue)" class="form-text text-danger"><i
                    class="fa fa-exclamation-triangle mr-2"
                    aria-hidden="true"
                  ></i>Valor supera o limite estabelecido pelo normativo.</small>
                    </b-col>
                    <b-col class="my-2">
                      <small class="form-text">Valor de IOF</small>
                      <span v-if="proposal.propertyType == 'Comecial' || proposal.operationModality == 'CRF'"><b>{{proposal.operationValue != 0 ? (proposal.operationValue*0.0323667) : (proposal.intendedFinancingValue*0.0323667) | currency}}</b></span>
                      <span v-else><i><b>Sem utilização</b></i></span>
                      
                      <small v-if="proposal.operationModality == 'CRF'" class="form-text text-warning"><i
                    class="fa fa-exclamation-triangle mr-2"
                    aria-hidden="true"
                  ></i>Valor aproximado deduzido do valor do empréstimo a ser creditado.</small>
                  <small v-else-if="proposal.propertyType == 'Comecial'" class="form-text text-warning"><i
                    class="fa fa-exclamation-triangle mr-2"
                    aria-hidden="true"
                  ></i>Valor aproximado que será pago em boleto.</small>
                  <small v-else></small>
                    </b-col>
                    </b-row>
                    <hr>

                    <b-col v-if="proposal.propertyType != 'Comecial' && proposal.operationModality != 'CRF' && !proposal.fgts" class="text-warning"
                  ><i
                    class="fa fa-info-circle mr-2"
                    aria-hidden="true"
                  ></i
                  >Proposta sem utilização de FGTS.
                </b-col>
                
                <b-col v-if="proposal.notaryExpenses" class="text-warnig"
                  ><i
                    class="fa fa-info-circle mr-2"
                    aria-hidden="true"
                  ></i
                  >Incluir despesas cartorárias.
                </b-col>
                <b-col v-else class="text-info"
                  ><i
                    class="fa fa-info-circle mr-2"
                    aria-hidden="true"
                  ></i
                  >Sem inclusão das despesas cartorárias.
                </b-col>
                <b-col v-if="proposal.propertyIQ && !proposal.verifiedSD" class="text-warning"
                  ><i
                    class="fa fa-exclamation-triangle mr-2"
                    aria-hidden="true"
                  ></i
                  >Proposta com saldo devedor a verificar.
                </b-col>
                <b-col v-else-if="proposal.propertyIQ && proposal.verifiedSD" class="text-info"
                  ><i
                    class="fa fa-info-circle mr-2"
                    aria-hidden="true"
                  ></i
                  >Saldo devedor verificado junto a(o) {{ bankingnDischargerIntervener }}.
                </b-col>
                <b-col v-else class="text-info"
                  ><i
                    class="fa fa-info-circle mr-2"
                    aria-hidden="true"
                  ></i
                  >Proposta sem interveniente quitante.
                </b-col>
                  </b-card-text>
                </b-card>
                </b-col>
              <b-col cols="3">
                
                <b-row>

                <b-col>
                  <div class="d-flex justify-content-between">
                    <p class="form-text text-muted mb-1">Fluxo de Contratação Realizado</p>
                  <i
                      class="fas fa-tasks mb-1"
                      v-b-tooltip.hover.top
                      :title="'Agência e Controles'"
                      @click="showBankBranchDialog = true"
                    ></i>
                  </div>
                  <!-- progress of proposal steps -->
                    <div class="d-flex flex-column  mt-3">
                      <b-form-select
                      v-if="proposal.bankBranch == ''"
                      ref="bankBranch"
                      v-model="proposal.bankBranch"
                      :options="bankBranches"
                      class="mb-2"
                      size="sm"
                    ></b-form-select>
                      <!-- Risk Assessment -->
                      <b-badge
                        class="my-1 p-2 pointer"
                        @click="showriskAssessmentDialog = true"
                        v-b-tooltip.hover.left
                        :title="
                          'Avaliação de risco ' +
                            proposal.steps.riskAssessment.situation +
                            ' e ' +
                            proposal.steps.riskAssessment.status
                        "
                        :variant="proposal.steps.riskAssessment.badgeColor"
                      >
                        <i
                          class="far fa-file-archive mr-1"
                          v-if="
                            proposal.steps.riskAssessment.situation.trim() == 'Em análise' ||
                              proposal.steps.riskAssessment.status.trim() ==
                                'Com pendência(s)' ||
                              proposal.steps.riskAssessment.status.trim() ==
                                'Com restrição' ||
                              proposal.steps.riskAssessment.status.trim() ==
                                'Com restrição e Com pendência(s)'
                          "
                        ></i>
                        <i
                          class="fas fa-chart-line mr-1"
                          v-if="
                            proposal.steps.riskAssessment.status.trim() == 'Aprovado' ||
                              proposal.steps.riskAssessment.status.trim() == 'Condicionado' ||
                              proposal.steps.riskAssessment.status.trim() == 'Reprovada'
                          "
                        ></i> Análise de Crédito
                      </b-badge>
                      <!-- Engineering -->
                      <b-badge
                        class="my-1 p-2 pointer"
                        @click="showPendingEngineeringDialog = true"
                        :variant="proposal.steps.engineering.badgeColor"
                        v-b-tooltip.hover.left
                        :title="
                          'Engenharia ' +
                            proposal.steps.engineering.situation +
                            ' e ' +
                            proposal.steps.engineering.status
                        "
                      >
                        <i class="fas fa-home mr-1"></i> Engenharia
                      </b-badge>
                      <!-- Forms -->
                      <b-badge
                        class="my-1 p-2 pointer"
                        @click="showPendingFormsDialog = true"
                        :variant="proposal.steps.forms.badgeColor"
                        v-b-tooltip.hover.left
                        :title="
                          'Formulários ' +
                            proposal.steps.forms.situation +
                            ' e ' +
                            proposal.steps.forms.status
                        "
                      >
                        <i class="far fa-file-pdf mr-1"></i> Formulários
                      </b-badge>
                      <!-- FGTS -->
                      <b-badge
                      v-if="proposal.fgts"
                        class="my-1 p-2 pointer"
                        @click="showPendingFgtsDialog = true"
                        v-b-tooltip.hover.left
                        :title="
                          'FGTS ' +
                            proposal.steps.fgts.situation +
                            ' e ' +
                            proposal.steps.fgts.status
                        "
                        :variant="proposal.steps.fgts.badgeColor"
                      >
                        <i class="fas fa-hand-holding-usd" ></i> FGTS
                      </b-badge>
                      <b-badge
                        class="my-1 p-2 pointer"
                        v-else
                        v-b-tooltip.hover.left
                        title="Sem utilização de FGTS"
                        variant="success"
                      >
                        <i class="fas fa-ban"></i> FGTS
                      </b-badge>
                      <!-- Sellers Documentation
                      <b-badge class="my-1 p-2 pointer" variant="light" v-b-tooltip.hover.left :title="``">
                        <i
                          class="fa fa-users mr-1"></i> Documentação do(s) Vendedor(es)
                      </b-badge> -->
                      <!-- SIOPI -->
                      <b-badge class="my-1 p-2 pointer" variant="light" v-b-tooltip.hover.left :title="`SIOPI`" @click="showSiopiDialog = true">
                        <i class="fas fa-home mr-1"></i> SIOPI
                      </b-badge>
                      <!-- Comitê -->
                      <b-badge class="my-1 p-2 pointer" v-if="proposal.comite && proposal.comiteChecked" v-b-tooltip.hover.left
                        :title="`Comitê liberado`" variant="success" @click="showComiteDialog = true">
                        <i class="fa fa-id-card mr-1" aria-hidden="true"></i> Comitê
                      </b-badge>
                      <b-badge class="my-1 p-2 pointer" v-else-if="proposal.comite && proposal.comiteIndeterminate" v-b-tooltip.hover.left
                        :title="`Comitê em processo`" variant="warning" @click="showComiteDialog = true">
                        <i class="fa fa-id-card mr-1" aria-hidden="true"></i> Comite
                      </b-badge>
                      <b-badge class="my-1 p-2 pointer" v-else-if="proposal.comite" v-b-tooltip.hover.left
                        :title="`Enviar docs para o comitê`" variant="light" @click="showComiteDialog = true">
                        <i class="fa fa-id-card mr-1" aria-hidden="true"></i> Comitê
                      </b-badge>
                      <!-- Dossier -->
                      <b-badge
                        class="my-1 p-2 pointer"
                        @click="showPendingDossieDialog = true"
                        v-b-tooltip.hover.left
                        :title="'Dossiê ' + proposal.steps.dossier.situation"
                        :variant="proposal.steps.dossier.badgeColor"
                        v-if="!proposal.comments"
                      >
                        <i
                          class="far fa-folder-open"
                          v-if="
                            !proposal.steps.dossier.actived ||
                              (proposal.steps.dossier.actived &&
                                proposal.steps.dossier.situation == 'Em montagem')
                          "
                        ></i> Dossiê
                        <i
                          class="fas fa-archive"
                          v-if="
                            proposal.steps.dossier.actived &&
                              proposal.steps.dossier.situation != 'Em montagem'
                          "
                        ></i> Dossiê
                      </b-badge>
                      <b-badge
                        v-else
                        class="my-1 p-2 pointer"
                        @click="showPendingDossieDialog = true"
                        v-b-tooltip.hover.bottom
                        :title="'Dossiê ' + proposal.steps.dossier.situation"
                        :variant="proposal.steps.dossier.badgeColor"
                      >
                        <i class="fas fa-exclamation-triangle"></i> Dossiê
                      </b-badge>
                      <!-- Contract -->
                      <b-badge
                        class="my-1 p-2 pointer"
                        @click="showPendingContractDialog = true"
                        v-b-tooltip.hover.left
                        :title="
                          'Escritura ' +
                            proposal.steps.contract.situation +
                            ' ' +
                            proposal.steps.contract.status
                        "
                        :variant="proposal.steps.contract.badgeColor"
                      >
                        <i
                          class="far fa-check-circle"
                          v-if="
                            !proposal.steps.contract.actived ||
                              proposal.steps.contract.situation ==
                                'Em análise de conformidade'
                          "
                        ></i>
                        <i
                          class="fas fa-file-contract text-light"
                          v-if="proposal.steps.contract.status == 'Agendada'"
                        ></i>
                        <i
                          class="fas fa-file-signature"
                          v-if="proposal.steps.contract.status == 'Contratada'"
                        ></i>
                        <i
                          class="fas fa-file-invoice-dollar"
                          v-if="proposal.steps.contract.status == 'Evoluída'"
                        ></i> Contrato
                      </b-badge>
                    </div>
              </b-col>
              </b-row>
              </b-col>
              </b-row>

              <b-row class="mt-4">

                <b-col class="pr-0">
                  <b-card header-bg-variant="light" border-variant="light" header="Observações de Complemento Pendente" style="max-height: 25rem;">
                    <b-card-text><p class="p-3">
                      <small class="form-text text-muted mb-1"
                    >Observações de Complemento Pendente</small
                  >
                      {{ proposal.comments }}</p></b-card-text>
                  </b-card>
                </b-col>
                <b-col>
                  <b-card header-bg-variant="light" border-variant="light" header="Observações" style="max-height: 25rem;">
                    <b-card-text><p class="p-3">{{ proposal.steps.note }}</p></b-card-text>
                  </b-card>
                </b-col>
                <b-col class="pl-0">
                  <b-card header-bg-variant="light" border-variant="light" header="Complementos Pendentes" style="max-height: 25rem;">
                    <b-card-text>
                      <div class="pendingText">
                      <div>
                        <!-- bidder list -->
                        <div>
                          <b-row v-if="!bidderList.every((el) => el.notShow)">
                            <b-col cols="6">
                              <div
                                class="
                                  text-dark
                                  d-flex
                                  align-items-center
                                  text-uppercase
                                "
                              >
                                <i class="dotIcon fas fa-dot-circle mr-2"></i>
                                <span><b>Proponente(s)/Coobrigado(s)</b></span>
                              </div>
                            </b-col>
                            <b-col
                              cols="4"
                              class="
                                d-flex
                                align-items-start
                                justify-content-start
                                px-4
                              "
                            >
                              <div class="pt-1">
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="task"
                                  v-if="!showbidderSubtask"
                                  @click="showbidderSubtask = true"
                                  class="d-flex align-items-center collapsed"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-down ml-2"
                                  ></i>
                                </span>
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="collapse"
                                  v-if="showbidderSubtask"
                                  @click="showbidderSubtask = false"
                                  class="d-flex align-items-center"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-up ml-2"
                                  ></i>
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <b-collapse
                            :id="`task`"
                            visible
                            v-model="showbidderSubtask"
                          >
                            <b-list-group class="mb-3">
                              <div
                                class="text-dark d-flex align-items-center ml-3"
                              >
                                <b-icon
                                  icon="person-fill"
                                  class="mr-2 mb-1"
                                ></b-icon>
                                <span>{{ proposal.name }}</span>
                              </div>
                              <div
                                v-for="(list, index) in bidderList"
                                :key="index"
                              >
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="!list.notShow"
                                >
                                  <div class="d-flex align-items-center">
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>{{ list.subItem }}</span>
                                  </div>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                            <b-list-group
                              v-for="(
                                participant, index
                              ) in proposal.participants"
                              :key="index"
                              class="mb-3"
                            >
                              <div
                                class="text-dark d-flex align-items-center ml-3"
                              >
                                <b-icon
                                  icon="person-fill"
                                  class="mr-2 mb-1"
                                ></b-icon>
                                <span>{{ participant.fullName }}</span>
                              </div>
                              <div
                                v-for="(
                                  list, index
                                ) in participant.participantList"
                                :key="index"
                              >
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="!list.notShow"
                                >
                                  <div class="d-flex align-items-center">
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>{{ list.subItem }}</span>
                                  </div>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                          </b-collapse>
                        </div>
                        <!-- pendingFgts List -->
                        <div>
                          <b-row
                            v-if="
                              proposal.fgts &&
                              !pendingFgtsList.every((el) => el.notShow)
                            "
                          >
                            <b-col cols="6">
                              <div
                                class="
                                  text-dark
                                  d-flex
                                  align-items-center
                                  text-uppercase
                                "
                              >
                                <i class="dotIcon fas fa-dot-circle mr-2"></i>
                                <span><b>Utilização de FGTS</b></span>
                              </div>
                            </b-col>
                            <b-col
                              cols="4"
                              class="
                                d-flex
                                align-items-start
                                justify-content-start
                                px-4
                              "
                            >
                              <div class="pt-1">
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="task"
                                  v-if="!showFgtsSubtask"
                                  @click="showFgtsSubtask = true"
                                  class="d-flex align-items-center collapsed"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-down ml-2"
                                  ></i>
                                </span>
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="collapse"
                                  v-if="showFgtsSubtask"
                                  @click="showFgtsSubtask = false"
                                  class="d-flex align-items-center"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-up ml-2"
                                  ></i>
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <b-collapse
                            v-if="proposal.fgts"
                            :id="`task`"
                            visible
                            v-model="showFgtsSubtask"
                          >
                            <b-list-group>
                              <div
                                v-for="(list, index) in pendingFgtsList"
                                :key="index"
                              >
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="!list.notShow"
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>{{ list.item }}</span>
                                  </div>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                          </b-collapse>
                        </div>
                        <!-- pending list -->
                        <div>
                          <b-row
                            v-if="
                              !(
                                proposal.matricula &&
                                parseInt(proposal.matricula) &&
                                proposal.issueDate &&
                                issueDateExpired === 'Válido' &&
                                !(
                                  proposal.pendingList &&
                                  proposal.pendingList.length &&
                                  proposal.pendingList.some((el) => !el.show)
                                )
                              )
                            "
                          >
                            <b-col cols="6">
                              <div
                                class="
                                  text-dark
                                  d-flex
                                  align-items-center
                                  text-uppercase
                                "
                              >
                                <i class="dotIcon fas fa-dot-circle mr-2"></i>
                                <span><b>Matrícula do Imóvel</b></span>
                              </div>
                            </b-col>
                            <b-col
                              cols="4"
                              class="
                                d-flex
                                align-items-start
                                justify-content-start
                                px-4
                              "
                            >
                              <div class="pt-1">
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="task"
                                  v-if="!showMatriculaSubtask"
                                  @click="showMatriculaSubtask = true"
                                  class="d-flex align-items-center collapsed"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-down ml-2"
                                  ></i>
                                </span>
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="collapse"
                                  v-if="showMatriculaSubtask"
                                  @click="showMatriculaSubtask = false"
                                  class="d-flex align-items-center"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-up ml-2"
                                  ></i>
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <b-collapse
                            :id="`task`"
                            visible
                            v-model="showMatriculaSubtask"
                          >
                            <b-list-group>
                              <b-list-group-item
                                class="text-dark px-3"
                                v-if="
                                  proposal.matricula &&
                                  parseInt(proposal.matricula) &&
                                  issueDateExpired === 'Vencido'
                                "
                              >
                                <div class="d-flex align-items-center">
                                  <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                  <img
                                    class="mr-2"
                                    src="@/assets/img/node-plus.svg"
                                  />
                                  <div>
                                    Matrícula enviada está vencida: emitida em
                                    <span>{{
                                      moment(proposal.issueDate).format(
                                        "DD/MM/YYYY"
                                      )
                                    }}</span>
                                  </div>
                                </div>
                              </b-list-group-item>
                              <b-list-group-item
                                v-if="
                                  (!proposal.matricula ||
                                    !parseInt(proposal.matricula)) &&
                                  pendingList.every((el) => !el.show)
                                "
                                class="text-dark px-3"
                              >
                                <div class="d-flex align-items-center">
                                  <img
                                    class="mr-2"
                                    src="@/assets/img/node-plus.svg"
                                  />
                                  <span>Documento não recebido.</span>
                                </div>
                              </b-list-group-item>
                              <b-list-group-item
                                class="text-dark px-3"
                                v-else-if="!proposal.issueDate"
                              >
                                <div class="d-flex align-items-center">
                                  <img
                                    class="mr-2"
                                    src="@/assets/img/node-plus.svg"
                                  />
                                  <div>
                                    Matrícula enviada está vencida: emitida em
                                  </div>
                                </div>
                              </b-list-group-item>

                              <div
                                v-for="(list, index) in pendingList"
                                :key="index"
                              >
                                <b-list-group-item
                                  v-if="
                                    !list.show &&
                                    proposal.matricula &&
                                    parseInt(proposal.matricula)
                                  "
                                  class="text-dark px-3"
                                >
                                  <div
                                    class="text-dark d-flex align-items-center"
                                  >
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>{{ list.subItem }}</span>
                                  </div>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                          </b-collapse>
                        </div>
                        <!-- property IQ list -->
                        <div>
                          <b-row
                            v-if="proposal.propertyIQ && !proposal.verifiedSD"
                          >
                            <b-col cols="6">
                              <div
                                class="
                                  text-dark
                                  d-flex
                                  align-items-center
                                  text-uppercase
                                "
                              >
                                <i class="dotIcon fas fa-dot-circle mr-2"></i>
                                <span
                                  ><b
                                    >Verificação do saldo devedor e do
                                    interveniente quitante</b
                                  ></span
                                >
                              </div>
                            </b-col>
                            <b-col
                              cols="4"
                              class="
                                d-flex
                                align-items-start
                                justify-content-start
                                px-4
                              "
                            >
                              <div class="pt-1">
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="task"
                                  v-if="!showPropertyIQSubtask"
                                  @click="showPropertyIQSubtask = true"
                                  class="d-flex align-items-center collapsed"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-down ml-2"
                                  ></i>
                                </span>
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="collapse"
                                  v-if="showPropertyIQSubtask"
                                  @click="showPropertyIQSubtask = false"
                                  class="d-flex align-items-center"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-up ml-2"
                                  ></i>
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <b-collapse
                            v-if="proposal.propertyIQ && !proposal.verifiedSD"
                            :id="`task`"
                            visible
                            v-model="showPropertyIQSubtask"
                          >
                            <b-list-group>
                              <div>
                                <b-list-group-item class="text-dark px-3">
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span
                                      >Verifique qual a instituição bancária do
                                      interveniente quitante e solicite a
                                      documentação necessária para a(s) data(s)
                                      prevista(s) da assinatura da minuta.</span
                                    >
                                  </div>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                          </b-collapse>
                        </div>
                        <!-- comite list -->
                        <div v-if="!proposal.comiteChecked && proposal.comite">
                          <b-row>
                            <b-col cols="6">
                              <div
                                class="
                                  text-dark
                                  d-flex
                                  align-items-center
                                  text-uppercase
                                "
                              >
                                <i class="dotIcon fas fa-dot-circle mr-2"></i>
                                <span
                                  v-if="
                                    proposal.comite &&
                                    (!proposal.comiteChecked ||
                                      proposal.comiteIndeterminate)
                                  "
                                  ><b>Comitê de Crédito</b></span
                                >
                              </div>
                            </b-col>
                            <b-col
                              cols="4"
                              class="
                                d-flex
                                align-items-start
                                justify-content-start
                                px-4
                              "
                            >
                              <div class="pt-1">
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="task"
                                  v-if="!showComiteSubtask"
                                  @click="showComiteSubtask = true"
                                  class="d-flex align-items-center collapsed"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-down ml-2"
                                  ></i>
                                </span>
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="collapse"
                                  v-if="showComiteSubtask"
                                  @click="showComiteSubtask = false"
                                  class="d-flex align-items-center"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-up ml-2"
                                  ></i>
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <b-collapse
                            :id="`task`"
                            visible
                            v-model="showComiteSubtask"
                          >
                            <b-list-group>
                              <b-list-group-item class="text-dark px-3">
                                <div class="d-flex align-items-center">
                                  <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                  <img
                                    class="mr-2"
                                    src="@/assets/img/node-plus.svg"
                                  />
                                  <span v-if="proposal.comiteIndeterminate"
                                    >Comitê de crédito em andamento.</span
                                  >
                                  <span v-else-if="!proposal.comiteChecked"
                                    >Comitê de crédito não enviado.</span
                                  >
                                </div>
                              </b-list-group-item>
                            </b-list-group>
                          </b-collapse>
                        </div>
                        <!-- form ist -->
                        <div
                          v-if="
                            proposal.steps.engineering.actived &&
                            proposal.steps.forms.status != 'Carimbados'
                          "
                        >
                          <b-row>
                            <b-col cols="6">
                              <div
                                class="
                                  text-dark
                                  d-flex
                                  align-items-center
                                  text-uppercase
                                "
                              >
                                <i class="dotIcon fas fa-dot-circle mr-2"></i>
                                <span><b>Formulários</b></span>
                              </div>
                            </b-col>
                            <b-col
                              cols="4"
                              class="
                                d-flex
                                align-items-start
                                justify-content-start
                                px-4
                              "
                            >
                              <div class="pt-1">
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="task"
                                  v-if="!showFormSubtask"
                                  @click="showFormSubtask = true"
                                  class="d-flex align-items-center collapsed"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-down ml-2"
                                  ></i>
                                </span>
                                <span
                                  aria-hidden="true"
                                  aria-expanded="false"
                                  aria-controls="collapse"
                                  v-if="showFormSubtask"
                                  @click="showFormSubtask = false"
                                  class="d-flex align-items-center"
                                >
                                  <i
                                    class="text-dark fa fa-chevron-up ml-2"
                                  ></i>
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <b-collapse
                            :id="`task`"
                            visible
                            v-model="showFormSubtask"
                          >
                            <b-list-group>
                              <div>
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="
                                    proposal.steps.engineering.actived &&
                                    !proposal.steps.forms.actived
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>Formulários não emitidos.</span>
                                  </div>
                                </b-list-group-item>
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="
                                    proposal.steps.engineering.actived &&
                                    proposal.steps.forms.actived &&
                                    proposal.steps.forms.situation ===
                                      'Emitidos' &&
                                    !proposal.fgts
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span
                                      >Formulários emitidos e não
                                      enviados.</span
                                    >
                                  </div>
                                </b-list-group-item>
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="
                                    proposal.steps.engineering.actived &&
                                    proposal.steps.forms.actived &&
                                    proposal.steps.forms.situation ===
                                      'Emitidos' &&
                                    proposal.steps.fgts.actived &&
                                    proposal.fgts
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>Formulários emitidos sem DAMP.</span>
                                  </div>
                                </b-list-group-item>
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="
                                    proposal.steps.engineering.actived &&
                                    proposal.steps.forms.actived &&
                                    proposal.steps.forms.situation ===
                                      'Enviados'
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span
                                      >Formulários enviados e não
                                      recebidos.</span
                                    >
                                  </div>
                                </b-list-group-item>
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="
                                    proposal.steps.engineering.actived &&
                                    proposal.steps.forms.actived &&
                                    proposal.steps.forms.situation ===
                                      'Recebidos' &&
                                    proposal.steps.forms.status === 'Inconforme'
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span
                                      >Formulários recebidos apresentam alguma
                                      pendência para aceitação.</span
                                    >
                                  </div>
                                </b-list-group-item>
                                <b-list-group-item
                                  class="text-dark px-3"
                                  v-if="
                                    proposal.steps.engineering.actived &&
                                    proposal.steps.forms.actived &&
                                    proposal.steps.forms.situation ===
                                      'Recebidos' &&
                                    proposal.steps.forms.status === 'À carimbar'
                                  "
                                >
                                  <div class="d-flex align-items-center">
                                    <!-- <i class="dotIcon fas fa-dot-circle mr-2"></i> -->
                                    <img
                                      class="mr-2"
                                      src="@/assets/img/node-plus.svg"
                                    />
                                    <span>Formulários não carimbados.</span>
                                  </div>
                                </b-list-group-item>
                              </div>
                            </b-list-group>
                          </b-collapse>
                        </div>
                      </div>
                    </div>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="d-flex justify-content-between my-4">
                <b-col lg="auto">
                  <small>Criado em: {{ getDateCreated }}</small>
                </b-col>
                <b-col lg="auto"> {{ proposal.id }}</b-col>
                <b-col lg="auto">
                  <small>Última atualização em: {{ getDateUpdated }}</small>
                </b-col>
              </b-row>
            </b-tab>

            <!--<b-tab title="Controle do Fluxo">
              <b-col cols="auto py-2 bg-light" style="border-bottom: 0.0625rem solid #e7eaf3; display: none;">
                <b-row class="d-flex align-items-center">
                  <b-col lg="auto">
                    <b-form-select
                      ref="bankBranch"
                      v-model="proposal.bankBranch"
                      :options="bankBranches"
                      class=""
                      size="sm"
                    ></b-form-select>
                  </b-col>
                  <b-col
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      pl-0
                    "
                  >
                    <b-form-checkbox switch v-model="proposal.actived" size="sm"
                      >Ativa</b-form-checkbox
                    >
                    
                    <b-form-checkbox
                      switch
                      v-model="proposal.expected"
                      size="sm"
                      >Prevista</b-form-checkbox
                    >
                    <b-form-checkbox
                    switch
                    size="sm"
                    v-model="proposal.propertyIQ"
                    >Imóvel c/ IQ</b-form-checkbox
                    >
                    <b-form-checkbox switch size="sm"
                      >Procurador</b-form-checkbox
                    >
                    <i
                      class="fa fa-trash-alt mb-1"
                      v-b-tooltip.hover.top
                      :title="'Excluir'"
                      @click="confirmDeleteProposal(proposal)"
                    ></i>
                  </b-col>
                </b-row>
              </b-col>
              <ControlOfTheProposalFlow></ControlOfTheProposalFlow>
            </b-tab>-->
            <!--<b-tab title="Proposta/Operação">
              <b-row class="py-2">
                <b-col md="12">
                  <h5 class="text-muted">Dados da Proposta Pretendida</h5>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Tipo do imóvel</small
                  >
                  <b-form-select
                    size="sm"
                    v-model="proposal.propertyType"
                    :options="optionsPropertyType"
                    class="mb-2"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Categoria do imóvel</small
                  >
                  <b-form-select
                    size="sm"
                    v-model="proposal.propertyCategory"
                    :options="optionsPropertyCategory"
                    class="mb-2"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Valor de Compra e Venda</small
                  >
                  <currency-input
                    class="mb-2 form-control form-control-sm"
                    maxlength="8"
                    v-model="proposal.propertyValue"
                    currency="BRL"
                    locale="pt"
                  />
                   <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.propertyValue"
                    v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
                    maxlength="16"
                    ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Valor de Financiamento Pretendido</small
                  >
                  <currency-input
                    class="mb-2 form-control form-control-sm"
                    maxlength="8"
                    v-model="proposal.intendedFinancingValue"
                    currency="BRL"
                    locale="pt"
                  />-->
                  <!-- <b-form-input
                  size="sm"
                  class="mb-2"
                  v-model="proposal.intendedFinancingValue"
                  v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
                  maxlength="16"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Sistema de Amortização</small
                  >
                  <b-form-select
                    size="sm"
                    v-model="proposal.amortizationSystem"
                    :options="optionsAmortizationSystem"
                    class="mb-2"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">Indexador</small>
                  <b-form-select
                    size="sm"
                    v-model="proposal.indexer"
                    :options="optionsIndexer"
                    class="mb-2"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Prazo Pretendido</small
                  >
                  <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.period"
                    maxlength="3"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Localização do Imóvel</small
                  >-->
                  <!-- <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.propertyLocation"
                  ></b-form-input>
                  <vue-google-autocomplete
                    ref="address"
                    id="map"
                    classname="form-control form-control-sm"
                    placeholder="Localização do Imóvel"
                    country="br"
                    v-on:placechanged="getAddressData"
                    v-model="locationData"
                    types=""
                    size="sm"
                  >
                  </vue-google-autocomplete>
                </b-col>
              </b-row>
              <b-row class="mt-5">
                <b-col md="12">
                  <h5 class="text-muted">Dados da Operação</h5>
                </b-col>
                
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Modalide de Financiamento</small
                  >
                  <b-form-select
                    size="sm"
                    v-model="proposal.operationModality"
                    :options="optionsOperationModality"
                    class="mb-2"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Valor de Financiamento Aprovado</small
                  >
                  <currency-input
                    ref="approvedFinancingAmount"
                    class="mb-2 form-control form-control-sm"
                    maxlength="9"
                    v-model="proposal.approvedFinancingAmount"
                    currency="BRL"
                    locale="pt"
                  />
                  <div
                    v-if="proposal.comite"
                    class="d-flex align-items-center justify-content-between"
                  >
                    <b-form-checkbox
                      class="py-1"
                      v-model="proposal.comiteChecked"
                      :indeterminate.sync="proposal.comiteIndeterminate"
                    >
                      <span v-if="proposal.comiteIndeterminate"
                        >Comitê em processo</span
                      >
                      <span v-else-if="!proposal.comiteChecked"
                        >Solicitar comitê</span
                      >
                      <span v-else>Comitê liberado</span>
                    </b-form-checkbox>
                    <i
                      v-if="
                        !proposal.comiteChecked && !proposal.comiteIndeterminate
                      "
                      @click="
                        proposal.comiteIndeterminate =
                          !proposal.comiteIndeterminate
                      "
                      class="alertIcon mr-3 pointer d-flex align-items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-send-slash"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                        />
                        <path
                          d="M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                        />
                      </svg>
                    </i>
                  </div> -->
                  <!-- {{ proposal.intendedFinancingValue }}

            <b-form-input
              size="sm"
              placeholder="Valor do Financiamento Aprovado"
              class="mb-2"
              v-model="proposal.approvedFinancingAmount"
              v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
              maxlength="16"
            ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Valor de Avaliação da Engenharia</small
                  >
                  <currency-input
                    ref="engineeringEvaluation"
                    class="mb-2 form-control form-control-sm"
                    maxlength="9"
                    v-model="proposal.engineeringEvaluation"
                    currency="BRL"
                    locale="pt"
                  />
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <small
                      @click="showMatriculaDialog = true"
                      class="form-text mb-1 pointer"
                      ><div>
                        <span class="text-info">Matrícula :</span>
                        {{ proposal.matricula }}
                        <span
                          v-if="proposal.issueDate"
                          :class="[
                            issueDateExpired === 'Vencido'
                              ? 'text-danger'
                              : 'text-success',
                          ]"
                        >
                          {{ issueDateExpired }}</span
                        >
                      </div>
                      <div>
                        <span class="text-info">Data de emissão :</span>
                        <span v-if="proposal.issueDate">{{
                          moment(proposal.issueDate).format("DD/MM/YYYY")
                        }}</span>
                      </div>
                    </small>
                    <img
                      v-if="proposal.matricula && parseInt(proposal.matricula)"
                      :src="
                        pendingList.every((el) => el.show)
                          ? require('@/assets/img/card-checklist-green.svg')
                          : pendingList.every((el) => !el.show)
                          ? require('@/assets/img/card-checklist-red.svg')
                          : require('@/assets/img/card-checklist-yellow.svg')
                      "
                      alt="icon"
                      width="30"
                      height="30"
                      class="pointer"
                      @click="showPendingDialog = true"
                    />
                  </div>-->
                  <!-- <b-form-input
                  size="sm"
                  placeholder="Valor de Avaliação de Engenharia"
                  class="mb-2"
                  v-model="proposal.engineeringEvaluation"
                  v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
                  maxlength="16"
                ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Valor da Operação</small
                  >
                  <currency-input
                    ref="operationValue"
                    class="form-control form-control-sm"
                    maxlength="9"
                    v-model="proposal.operationValue"
                    currency="BRL"
                    locale="pt"
                  />
                  <b-form-text class="mt-0">
                    <i v-if="proposal.notaryExpenses" class="text-info"
                      >Incluir despesas cartorárias.
                    </i>
                    <i v-else class="text-info"
                      >Sem inclusão das despesas cartorárias.
                    </i>
                  </b-form-text>
                  <b-form-text
                    v-if="proposal.propertyIQ"
                    class="mt-0 d-flex align-items-center"
                  >
                    <b-form-checkbox
                      v-model="proposal.verifiedSD"
                    ></b-form-checkbox>
                    <i
                      :class="
                        !proposal.verifiedSD ? 'text-danger' : 'text-success'
                      "
                    >
                      Verificar SD do contrato anterior.
                      {{ bankingnDischargerIntervener }}
                    </i>
                    <i
                      class="fa fa-info-circle text-info ml-2"
                      v-b-tooltip.hover.top
                      title="Solicitar a tela PDL ao gerente para verificação se o SD está ativo, sem impecílhos e se o mesmo é menor ou igual ao valor de financiamento."
                    ></i>
                  </b-form-text>
                </b-col>

                <b-col md="3" v-if="proposal.notaryExpenses">
                  <small class="form-text text-muted mb-1"
                    >Valor das Despesas Cartorárias</small
                  >
                  <currency-input
                    ref="notaryExpensesAmount"
                    class="mb-2 form-control form-control-sm"
                    v-model="proposal.notaryExpensesAmount"
                    currency="BRL"
                    locale="pt"
                    maxlength="9"
                  />
                </b-col>
              </b-row>
              <b-row class="mt-5" v-if="proposal.fgts">
                <b-col md="12">
                  <h5 class="text-muted">Dados da Operação do FGTS</h5>
                </b-col>
                <b-col md="3">
                  <div class="d-flex justify-content-between">
                    <small class="form-text text-muted mb-1"
                      >Nº da Operação</small
                    >
                    <img
                      :src="
                        pendingFgtsList.every((el) => el.notShow)
                          ? require('@/assets/img/card-checklist-green.svg')
                          : pendingFgtsList.every((el) => !el.notShow)
                          ? require('@/assets/img/card-checklist-red.svg')
                          : require('@/assets/img/card-checklist-yellow.svg')
                      "
                      alt="icon"
                      width="30"
                      height="30"
                      class="pointer"
                      @click="showPendingFgtsDialog = true"
                    />
                  </div>
                  <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.operationNumber"
                    v-mask="['#####-#-##-######-#']"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">Valor de FGTS</small>
                  <currency-input
                    ref="fgtsValue"
                    class="mb-2 form-control form-control-sm"
                    v-model="proposal.fgtsValue"
                    currency="BRL"
                    locale="pt"
                    maxlength="9"
                  />
                </b-col>
              </b-row>
            </b-tab>-->
            <b-tab title="Anotações">
              <b-row class="d-flex flex-column py-2">
                <b-col>
                  <small class="form-text text-muted mb-1"
                    >Observações da Proposta - Não impeditivas</small
                  >
                  <b-form-textarea
                    v-model="proposal.steps.note"
                    class="mb-3"
                    size="sm"
                    placeholder="Observação referente a situação da proposta"
                    rows="2"
                    max-rows="8"
                  ></b-form-textarea>
                </b-col>
                <hr />
                <b-col>
                  <small class="form-text text-muted mb-1">Observações de Complemento Pendente</small>

                  <b-form-textarea
                    v-model="proposal.comments"
                    class="mb-3"
                    size="sm"
                    placeholder="Checklist - Observações da proposta"
                    rows="3"
                    max-rows="8"
                  ></b-form-textarea>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Proponente(s)/Coobrigado(s)">
              <b-row class="mb-4 py-2 ">
                <b-col>
                  <small class="form-text text-muted mb-1"
                    >Checklist dos Proponente(s)/Coobrigado(s)</small
                  >
                  <div class="d-flex">
                    <div @click="showBidderDialog = true">
                      <b-icon
                        v-if="bidderList.every((el) => el.notShow)"
                        variant="success"
                        icon="person-check-fill"
                      ></b-icon>
                      <b-icon
                        v-else-if="bidderList.every((el) => !el.notShow)"
                        variant="danger"
                        icon="person-x-fill"
                      ></b-icon>
                      <b-icon
                        v-else
                        variant="warning"
                        icon="person-dash-fill"
                      ></b-icon>
                    </div>
                    <div
                      class="ml-4"
                      v-for="(participant, index) in proposal.participants"
                      :key="index"
                      @click="handleParticipantModal(index)"
                    >
                      <b-icon
                        v-if="
                          participant.participantList.every((el) => el.notShow)
                        "
                        variant="success"
                        icon="person-check-fill"
                      ></b-icon>
                      <b-icon
                        v-else-if="
                          participant.participantList.every((el) => !el.notShow)
                        "
                        variant="danger"
                        icon="person-x-fill"
                      ></b-icon>
                      <b-icon
                        v-else
                        variant="warning"
                        icon="person-dash-fill"
                      ></b-icon>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">Nome</small>
                  <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.name"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">CPF</small>
                  <b-form-input
                    size="sm"
                    class="mb-2 cpf"
                    v-model="proposal.cpf"
                    v-mask="['###.###.###-##']"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">PIS</small>
                  <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.pis"
                    v-mask="['###.#####.##-#']"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">Profissão</small>
                  <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.occupation"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">Estado civil</small>
                  <b-form-select
                    size="sm"
                    v-model="proposal.maritalStatus"
                    :options="maritalStatus_options"
                    class="mb-2"
                  ></b-form-select>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">Telefone</small>
                  <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.phoneNumber"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1">E-mail</small>
                  <b-form-input
                    size="sm"
                    type="email"
                    class="mb-2"
                    v-model="proposal.email"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <small class="form-text text-muted mb-1"
                    >Valor do salário</small
                  >
                  <currency-input
                    class="form-control form-control-sm mb-2"
                    maxlength="15"
                    v-model.lazy="proposal.salaryAmount"
                    currency="BRL"
                    locale="pt"
                    :distraction-free="false"
                    :auto-decimal-mode="true"
                  />
                </b-col>
              </b-row>
              <b-row class="my-4" v-if="proposal.participants.length">
                <!--<b-col md="12">
                  <h6 v-if="proposal.participants.length">Participante(s)</h6>
                </b-col>-->
                <b-col
                  v-for="(participant, index) in proposal.participants"
                  :key="index"
                  md="12"
                >
                  <b-row>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1">Nome</small>
                      <b-form-input
                        size="sm"
                        class="mb-2"
                        v-model="participant.fullName"
                      ></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1">CPF</small>
                      <b-form-input
                        size="sm"
                        class="mb-2 cpf"
                        v-model="participant.cpf"
                        v-mask="['###.###.###-##']"
                      ></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1">PIS</small>
                      <b-form-input
                        size="sm"
                        class="mb-2"
                        v-model="participant.pis"
                        v-mask="['###.#####.##-#']"
                      ></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1">Profissão</small>
                      <b-form-input
                        size="sm"
                        class="mb-2"
                        v-model="participant.occupation"
                      ></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1"
                        >Estado civil</small
                      >
                      <b-form-select
                        size="sm"
                        v-model="participant.maritalStatusField"
                        :options="maritalStatus_options"
                        class="mb-2"
                      ></b-form-select>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1">Telefone</small>
                      <b-form-input
                        size="sm"
                        class="mb-2"
                        v-model="participant.phoneNumber"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                      ></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1">E-mail</small>
                      <b-form-input
                        size="sm"
                        type="email"
                        class="mb-2"
                        v-model="participant.email"
                      ></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <small class="form-text text-muted mb-1"
                        >Valor do salário</small
                      >
                      <currency-input
                        class="form-control form-control-sm mb-2"
                        maxlength="15"
                        v-model.lazy="participant.salaryAmount"
                        currency="BRL"
                        locale="pt"
                        :distraction-free="false"
                        :auto-decimal-mode="true"
                      />
                    </b-col>
                    <b-col
                      md="3"
                      v-if="
                        participant.stableUnionWith &&
                        Object.keys(participant.stableUnionWith).length
                      "
                    >
                      <small class="form-text text-muted mb-1"
                        >Stable union with</small
                      >
                      <b-form-input
                        size="sm"
                        class="mb-2"
                        v-model="participant.stableUnionWith.name"
                      ></b-form-input>
                    </b-col>
                    <b-col
                      md="3"
                      v-if="
                        participant.marriedWith &&
                        Object.keys(participant.marriedWith).length
                      "
                    >
                      <small class="form-text text-muted mb-1"
                        >Married With</small
                      >
                      <b-form-input
                        size="sm"
                        class="mb-2"
                        v-model="participant.marriedWith.name"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="my-3">
                <b-col md="12">
                  <h6 class="text-muted">Informações complementares</h6>
                </b-col>
                <b-col md="12">
                  <b-form-checkbox-group
                    class="mb-4"
                    name="checkbox-1"
                    :options="participantsItemsOptions"
                    v-model="proposal.participantItems"
                    stacked
                  >
                  </b-form-checkbox-group>
                </b-col>
                <b-col md="12">
                  <h6 class="text-muted">Previsão de aquisição de imóvel</h6>
                </b-col>
                <b-col md="12">
                  <b-form-group>
                    <b-form-radio-group
                      v-model="proposal.acquisitionForecast"
                      :options="acquisitionForecastOptions"
                      stacked
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Documentos">
              <b-row class="my-1 py-2">
                <b-col>
                  <small class="form-text text-muted mb-1">
                    Documents
                    <i class="fas fa-print float-right"></i>
                    <i class="fas fa-download float-right"></i>
                    <i class="fas fa-upload float-right"></i>
                    <i class="fas fa-tasks float-right" v-b-toggle.sidebar></i>
                  </small>
                  <hr style="margin-top: 8px" />
                  <div class="d-flex flex-wrap my-3">
                    <b-badge
                      v-for="(pdf, pdfIndex) in documentFiles.pdfArray"
                      :key="pdfIndex"
                      pill
                      variant="danger"
                      class="mr-2 my-2 py-2"
                      @click="openPdfModal(pdf.url)"
                      >{{ pdf.name }}</b-badge
                    >
                    <!-- <b-badge
                v-for="(png, pngIndex) in documentFiles.pngArray"
                :key="pngIndex"
                pill
                variant="success"
                class="mr-2 py-2"
                @click="openImage(pngIndex)"
              >{{png.name}}</b-badge>-->
                  </div>

                  <b-modal
                    v-model="modalShow"
                    :pdfUrl="pdfUrl"
                    size="xl"
                    hide-header
                    hide-footer
                    id="largeDialog"
                  >
                    <object :data="pdfUrl" width="100%" height="100%"></object>
                  </b-modal>

                  <viewer
                    :images="documentFiles.pngArray"
                    v-if="documentFiles.pngArray && documentFiles.pngArray"
                  >
                    <!-- ref="viewer"
              @inited="inited"-->
                    <img
                      class="documentImages"
                      :src="file.url"
                      v-for="(file, index) in documentFiles.pngArray"
                      :key="index"
                    />
                  </viewer>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Histórico" v-if="user.email == `contato@parceirocaixa.com.br`">
              <b-row class="mt-5 py-2">
                <b-col class="text-center">
                  <TimeLineModal
                    :show="timelineModal"
                    :timelineArray="timelineArray"
                    :loading="loadingTimeline"
                    @hideModal="timelineModal = false"
                  ></TimeLineModal>
                  <a
                    v-if="timelineArray == ''"
                    class="btn btn-outline-secondary btn-sm"
                    alt="Clique para carregar"
                    @click="viewTimeline(proposal)"
                  >
                    <i class="fa fa-history" aria-hidden="true"></i>
                    Clique para carregar
                  </a>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </form>
    </div>
    <div>
      <b-sidebar
        title="Checklist"
        id="sidebar"
        shadow
        width="400px"
        style="z-index: 9999"
      >
        <div class="px-3">
          <div>
            <b-form-select
              class="bg-transparent px-3 mt-2"
              v-model="selectedTaskList"
              @input="selectOption"
              style="
                height: 100%;
                border: none;
                font-size: 20px;
                font-weight: 600;
              "
            >
              <b-form-select-option value="buyer">Buyer</b-form-select-option>
              <b-form-select-option value="seller">Seller</b-form-select-option>
              <b-form-select-option value="property"
                >Property</b-form-select-option
              >
            </b-form-select>
            <hr style="border-top: 1px solid #ccc; padding: 0px" />
            <!-- <div class="d-flex">
              <b-form-input placeholder="Add Task" @keyup.enter="addTask" v-model="task" type="text"></b-form-input>
            </div>-->
            <!-- <button @click="addtassk">Adddddd</button> -->
            <!-- <div class="p-0" v-if="selectedTaskList == 'buyer' || selectedTaskList == 'seller'">s -->
            <b-card
              no-body
              class="fixed-bottom bg-transparent"
              style="border: none"
            >
              <b-tabs v-model="tabIndex" pills card end align="center">
                <b-tab title="All">
                  <Tasktab
                    :taskListArray="taskListArray"
                    :selectedTaskList="selectedTaskList"
                    :tabIndex="tabIndex"
                    :isLoading="isLoading"
                  />
                </b-tab>
                <b-tab title="Active" active>
                  <Tasktab
                    :taskListArray="taskListArray"
                    :selectedTaskList="selectedTaskList"
                    :tabIndex="tabIndex"
                    :isLoading="isLoading"
                  />
                </b-tab>
                <b-tab title="Completed">
                  <Tasktab
                    :taskListArray="taskListArray"
                    :selectedTaskList="selectedTaskList"
                    :tabIndex="tabIndex"
                    :isLoading="isLoading"
                  />
                </b-tab>
                <b-tab title="Not Required">
                  <Tasktab
                    :taskListArray="taskListArray"
                    :selectedTaskList="selectedTaskList"
                    :tabIndex="tabIndex"
                    :isLoading="isLoading"
                  />
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import db from "../main";
import router from "../router";
import { mapActions, mapState, mapMutations } from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { mask } from "vue-the-mask";
// import { CurrencyDirective } from 'vue-currency-input';
import { CurrencyInput } from "vue-currency-input";
import ControlOfTheProposalFlow from "../components/ProposalsTypes/ControlOfTheProposalFlow.vue";
import ControlOfTheFgtsFlow from "../components/ProposalsTypes/ControlOfTheFgtsFlow.vue";
import ControlOfTheFormsFlow from "../components/ProposalsTypes/ControlOfTheFormsFlow.vue";
import ControlOfTheDossieFlow from "../components/ProposalsTypes/ControlOfTheDossieFlow.vue";
import ControlOfTheContractFlow from "../components/ProposalsTypes/ControlOfTheContractFlow.vue";
import ControlOfTheRiskAssessmentFlow from "../components/ProposalsTypes/ControlOfTheRiskAssessmentFlow.vue";
import ControlOfTheEngineeringFlow from "../components/ProposalsTypes/ControlOfTheEngineeringFlow.vue";
import ControlOfTheSiopiFlow from "../components/ProposalsTypes/ControlOfTheSiopiFlow.vue";
import TimeLineModal from "../components/common/Timeline";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import Tasktab from "@/components/Tasktab.vue";
Vue.use(Viewer);
var moment = require("moment");
moment.locale("pt-BR");

var bootstrap = require("bootstrap");
var bootbox = require("bootbox");

// Situations and Status Of Risk Assessment
var situationsOfriskAssessment_options = [
  { value: "Em análise", text: "Em análise" },
  { value: "Analisado", text: "Analisado" },
];
var statusOfriskAssessment_options = {
  Analisado: [
    { value: "Aprovado", text: "Aprovado", badgeColor: "primary" },
    { value: "Condicionado", text: "Condicionado", badgeColor: "info" },
    { value: "Reprovado", text: "Reprovado", badgeColor: "danger" },
    {
      value: "Com pendência(s)",
      text: "Com pendência(s)",
      badgeColor: "warning",
    },
    { value: "Com restrição", text: "Com restrição", badgeColor: "warning" },
    {
      value: "Com restrição e com pendência",
      text: "Com restrição e com pendência",
      badgeColor: "warning",
    },
  ],
};

// Situations and Status Of Engineering
var situationsOfEngineering_options = [
  { value: "Boleto", text: "Boleto" },
  { value: "Convocada", text: "Convocada" },
  { value: "Emitida", text: "Emitida" },
  { value: "Laudo", text: "Laudo" },
];
var statusOfEngineering_options = {
  Laudo: [
    { value: "Válido", text: "Válido" },
    { value: "Inválido", text: "Inválido" },
    { value: "Pept", text: "Pept" },
  ],
};

// Situations and Status Of Forms
var situationsOfForms_options = [
  { value: "Emitidos", text: "Emitidos" },
  { value: "Enviados", text: "Enviados" },
  { value: "Recebidos", text: "Recebidos" },
];
var statusOfForms_options = {
  Recebidos: [
    { value: "Inconforme", text: "Inconforme" },
    { value: "À carimbar", text: "À carimbar" },
    { value: "Carimbados", text: "Carimbados" },
  ],
};

// Situations and Status Of FGTS
var situationsOfFgts_options = [
  { value: "Cadastrado", text: "Cadastrado" },
  { value: "Solicitado", text: "Solicitado" },
];
var statusOfFgts_options = {
  Solicitado: [
    {
      value: "Liberação de ressarcimento solicitada",
      text: "Liberação de ressarcimento solicitada",
    },
    { value: "Com erro", text: "Com erro" },
    { value: "Ressarcida", text: "Ressarcida" },
  ],
};

// Situations Of Dossier
var situationsOfDossier_options = [
  { value: "Em montagem", text: "Em montagem" },
  { value: "Montado", text: "Montado" },
  { value: "Entregue", text: "Entregue" },
];

// Situations and Status Of Contract
var situationsOfContract_options = [
  { value: "Em análise de conformidade", text: "Em análise de conformidade" },
  { value: "Emitida", text: "Emitida" },
];
var statusOfContract_options = {
  "Em análise de conformidade": [
    { value: "Enviando", text: "Enviando" },
    { value: "Enviado", text: "Enviado" },
    { value: "Conforme", text: "Conforme" },
    { value: "Com exigência", text: "Com exigência" },
    { value: "Reenviada", text: "Reenviada" },
  ],
  Emitida: [
    { value: "Agendada", text: "Agendada" },
    { value: "Contratada", text: "Contratada" },
    { value: "Evoluída", text: "Evoluída" },
  ],
};

export default {
  name: "EditProposal",
  components: {
    VueGoogleAutocomplete,
    ControlOfTheProposalFlow,
    ControlOfTheFgtsFlow,
    ControlOfTheFormsFlow,
    ControlOfTheDossieFlow,
    ControlOfTheContractFlow,
    ControlOfTheEngineeringFlow,
    ControlOfTheRiskAssessmentFlow,
    ControlOfTheSiopiFlow,
    CurrencyInput,
    TimeLineModal,
    Tasktab,
  },
  data() {
    return {
      id: this.$route.params.id,
      badgeColor: "primary",
      make: null,
      model: null,
      situationsOfriskAssessment_options: situationsOfriskAssessment_options,
      statusOfriskAssessment_options: statusOfriskAssessment_options,
      situationsOfEngineering_options: situationsOfEngineering_options,
      statusOfEngineering_options: statusOfEngineering_options,
      situationsOfForms_options: situationsOfForms_options,
      statusOfForms_options: statusOfForms_options,
      /*situationsOfFgts_options: situationsOfFgts_options,
      statusOfFgts_options: statusOfFgts_options,*/
      situationsOfDossier_options: situationsOfDossier_options,
      situationsOfContract_options: situationsOfContract_options,
      statusOfContract_options: statusOfContract_options,
      maritalStatus_options: [
        { value: null, text: "Informe o estado civil" },
        { value: "Solteiro", text: "Solteiro" },
        { value: "Casado", text: "Casado" },
        { value: "Divorciado/Separado", text: "Divorciado/Separado" },
        { value: "Viúvo", text: "Viúvo" },
      ],
      bankingnDischargerIntervener: "",
      bankingnDischargerIntervenerOptions: [
        {
          value: "033 - Banco Bradesco S.A.",
          text: "033 - Banco Bradesco S.A.",
          info: "Cliente deverá solicitar o boleto de quitação e procurações junto ao seu gerente.",
        },
        {
          value: "104 - Caixa Econômica Federal",
          text: "104 - Caixa Econômica Federal",
          info: "Solicitar a tela PDL para o gerente",
        },
        {
          value: "341 - Itaú Unibanco S.A.",
          text: "341 - Itaú Unibanco S.A.",
          info: "Enviar e-mail para XXXX solicitando o boleto de quitação.",
        },
      ],
      timelineModal: false,
      loadingTimeline: false,
      timelineArray: [],
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      modalShow: false,
      pdfUrl: "",
      index: 0,
      images: [],
      buyer: false,
      task: "",
      buyerTask: {
        name: "",
        value: false,
        subtask: [],
      },
      sellerTask: {
        name: "",
        value: false,
        subtask: [],
      },
      propertyTask: {
        name: "",
        value: false,
        subtask: [],
      },
      subBuyerInput: [],
      subSellerInput: [],
      subPropertyInput: [],
      selectedTaskList: "buyer",
      taskListArray: [],
      propertyTaskList: [],
      buyerSubTask: [],
      subTaskdata: {
        html: "",
      },
      editTask: [],
      // showSellerGroup: [false],
      // showPropertyGroup: [false],
      showCompletedBuyerGroup: false,
      selectedItem: [],
      participantsItemsOptions: [
        { text: "Tem pretenção de utilizar o FGTS.", value: "a" },
        { text: "Possui imóvel na cidade do imóvel pretendido.", value: "b" },
        {
          text: "Tem 36 meses de trabalho sob regime do FGTS, somado todos os períodos trabalhados sendo consecutivos ou não de FGTS.",
          value: "c",
        },
        { text: "Tem mais de um comprador ou dependente.", value: "d" },
        { text: "É servidor público", value: "e" },
        {
          text: "Tem ou gostaria de ter relacionamento com a CAIXA.",
          value: "f",
        },
        {
          text: "Tem ou gostaria de ter crédito salário na CAIXA.",
          value: "g",
        },
      ],
      acquisitionForecastOptions: [
        //{ value: null, text: "Selecione uma opção" },
        { value: "a", text: "Cliente já possui imóvel em vista." },
        { value: "b", text: "Cliente está procurando imóvel." },
        { value: "c", text: "Está analisando a possibilidade de crédito." },
      ],
      tabIndex: 0,
      isLoading: false,
      showUserList: false,
      sharedUsers: [],
      searchUser: "",
      showMatriculaDialog: false,
      moment: moment,
      showriskAssessmentDialog: false,
      showBankBranchDialog: false,
      showMatriculaSubtask: false,
      showComiteSubtask: false,
      showFgtsSubtask: false,
      showPropertyIQSubtask: false,
      showFormSubtask: false,
      showbidderSubtask: false,
      showPendingDialog: false,
      showPendingFgtsDialog: false,
      showPendingEngineeringDialog: false,
      showPendingFormsDialog: false,
      showComiteDialog: false,
      showPendingDossieDialog: false,
      showSiopiDialog: false,
      showPendingContractDialog: false,
      showBidderDialog: false,
      showAlertMatricula: false,
      showAlertMatriculaMessage: "",
      showAlertMatriculaVariant: "",
      pendingList: [
        {
          item: "Matrícula é de inteiro teor",
          subItem:
            "Solicitar matrícula de inteiro teor com ônus reais e/ou ações reipercussórias",
          show: false,
        },
        {
          item: "Matrícula é de ônus reais e/ou ações reipercussórias",
          subItem:
            "Solicitar matrícula de inteiro teor com ônus reais e/ou ações reipercussórias",
          show: false,
        },
        {
          item: "Foi localizado o habite-se",
          subItem:
            "Verifique a necessidade de solicitação do habite-se ou declaração da prefeitura local para comprovação de legalização do imóvel",
          show: false,
        },
        {
          item: "Verificado se o imóvel foi adquirido há menos de 3 e se foi ou não utilizado FGTS na aquisição.",
          subItem:
            "Proposta não permite utilização de FGTS. Imóvel adquirido com utlização de FGTS há menos de 3 anos.",
          show: false,
        },
        {
          item: "Todos os nomes e CPFs dos vendedores estão averbados corretamente.",
          subItem:
            "Solicite consulta ao jurídico para prosseguir com a averbação concomitante dos dados não localizados.",
          show: false,
        },
      ],
      pendingFgtsList: [
        {
          item: "Autorização de FGTS no App.",
          subItem: "Solicitar autorização do cliente no app do FGTS.",
          notShow: false,
        },
        {
          item: "Extrato analítico.",
          subItem: "Solicitar extrato analítico a agência.",
          notShow: false,
        },
        {
          item: "Possui 36 meses de contribuição ao FGTS?",
          subItem:
            "Conferir se o cliente possuir no mínimo 36 meses de contribuição ao FGTS.",
          notShow: false,
        },
        {
          item: "Cliente não possui imóvel.",
          subItem: "Verifique se o cliente não possui imóvel.",
          notShow: false,
        },
        {
          item: "Declaração de IR com o respectivo recibo de entrega.",
          subItem:
            "Verifique se houve declaração de IR e recebimento do documento.",
          notShow: false,
        },
        {
          item: "Imóvel está situação no mesmo município de moradia/trabalho do cliente.",
          subItem:
            "Verifique se o imóvel objeto da operação pertence ao município que o cliente reside ou pretende trabalhar.",
          notShow: false,
        },
      ],
      bidderList: [
        {
          item: "Pesquisa Cadastral - NADA CONSTA",
          subItem: "Proponente com restrição cadastral.",
          notShow: false,
        },
        {
          item: "Não existe avaliação de risco solicitada impedindo o cadastro",
          subItem:
            "Existe avaliação de risco solicitada impedindo o prosseguimento da proposta.",
          notShow: false,
        },
        {
          item: "Documento de Identificação/CPF legível",
          subItem:
            "Documento de identificação/CPF do proponente está ilegível.",
          notShow: false,
        },
        {
          item: "Documento de Identificação apresenta averbação de estado civil igual ao documento enviado",
          subItem:
            "Averbação de estado civil no documento de identificação não coincide com a certidão de estado civil enviada.",
          notShow: false,
        },
        {
          item: "Nomes atualizados na Receita conforme documento recebido x certidão de estado civil que estejam dentro da regra que possamos prosseguir com a proposta.",
          subItem:
            "Nome do(a) proponente desatualizado na Receita e no documento ou desatualizado na Receita e atualizado no documento ou desatualizado no documento que foi emitido depois do casamento.",
          notShow: false,
        },
        {
          item: "Certidão de estado civil legível/recebido",
          subItem: "Documento de estado civil não recebido ou ilegível.",
          notShow: false,
        },
        {
          item: "Comprovante de residência atualizado e no nome do proponente/coobrigado",
          subItem:
            "Comprovante de residência desatualizado e/ou não está no nome do proponente/coobrigado",
          notShow: false,
        },
        {
          item: "Tela SISGR",
          subItem:
            "Solicitar tela SISGR para comprovação que não houve data de saída, verificação da contribuição dos 36 meses de FGTS para redutor PCVA e enquadramento PROCOTISTA e pegar o nº do PIS e data de admissão.",
          notShow: false,
        },
        {
          item: "Comprovante de renda atualizado e no nome do proponente sem férias, 13º ou algum adicional relevante que seja impeditivo de prosseguir",
          subItem:
            "Contracheque desatualizado e/ou possui férias, 13º ou algum adicional relevante impeditivo de prosseguir",
          notShow: false,
        },
        {
          item: "Declaração de Imposto de Renda com o respectivo recibo de entrega dentro do ano de exercício atual e entregue dentro do prazo",
          subItem:
            "Declaração de Imposto de Renda com o respectivo recibo de entrega entregue fora do prazo e/ou não é do exercício atual.",
          notShow: false,
        },
        {
          item: "Declaração de Imposto de Renda com o respectivo recibo de entrega retificadora com o recebimento das demais retificadoras e Original",
          subItem:
            "Declaração de Imposto de Renda com o respectivo recibo de entrega retificadora sem o recebimento da Original e, se for o caso, demais retificadoras.",
          notShow: false,
        },
      ],
      participantList: [
        {
          item: "Pesquisa Cadastral - NADA CONSTA",
          subItem: "Proponente com restrição cadastral.",
          notShow: false,
        },
        {
          item: "Não existe avaliação de risco solicitada impedindo o cadastro",
          subItem:
            "Existe avaliação de risco solicitada impedindo o prosseguimento da proposta.",
          notShow: false,
        },
        {
          item: "Documento de Identificação/CPF legível",
          subItem:
            "Documento de identificação/CPF do proponente está ilegível.",
          notShow: false,
        },
        {
          item: "Documento de Identificação apresenta averbação de estado civil igual ao documento enviado",
          subItem:
            "Averbação de estado civil no documento de identificação não coincide com a certidão de estado civil enviada.",
          notShow: false,
        },
        {
          item: "Nomes atualizados na Receita conforme documento recebido x certidão de estado civil que estejam dentro da regra que possamos prosseguir com a proposta.",
          subItem:
            "Nome do(a) proponente desatualizado na Receita e no documento ou desatualizado na Receita e atualizado no documento ou desatualizado no documento que foi emitido depois do casamento.",
          notShow: false,
        },
        {
          item: "Certidão de estado civil legível/recebido",
          subItem: "Documento de estado civil não recebido ou ilegível.",
          notShow: false,
        },
        {
          item: "Comprovante de residência atualizado e no nome do proponente/coobrigado",
          subItem:
            "Comprovante de residência desatualizado e/ou não está no nome do proponente/coobrigado",
          notShow: false,
        },
        {
          item: "Tela SISGR",
          subItem:
            "Solicitar tela SISGR para comprovação que não houve data de saída, verificação da contribuição dos 36 meses de FGTS para redutor PCVA e enquadramento PROCOTISTA e pegar o nº do PIS e data de admissão.",
          notShow: false,
        },
        {
          item: "Comprovante de renda atualizado e no nome do proponente sem férias, 13º ou algum adicional relevante que seja impeditivo de prosseguir",
          subItem:
            "Contracheque desatualizado e/ou possui férias, 13º ou algum adicional relevante impeditivo de prosseguir",
          notShow: false,
        },
        {
          item: "Declaração de Imposto de Renda com o respectivo recibo de entrega dentro do ano de exercício atual e entregue dentro do prazo",
          subItem:
            "Declaração de Imposto de Renda com o respectivo recibo de entrega entregue fora do prazo e/ou não é do exercício atual.",
          notShow: false,
        },
        {
          item: "Declaração de Imposto de Renda com o respectivo recibo de entrega retificadora com o recebimento das demais retificadoras e Original",
          subItem:
            "Declaração de Imposto de Renda com o respectivo recibo de entrega retificadora sem o recebimento da Original e, se for o caso, demais retificadoras.",
          notShow: false,
        },
      ],
      selectedParticipant: 0,
    };
  },
  mutations: {
    ...mapMutations([
      "setErrorMessage",
      "setProposalToEdit",
      "setProposalToCheck",
    ]),
  },
  watch: {
    "proposal.shareWith"(newVal) {
      this.sharedUsers = newVal;
    },
    "proposal.approvedFinancingAmount"(newVal) {
      if (newVal >= 300000) {
        this.proposal.comite = true;
      }
    },
    pendingList: {
      handler: function (val) {
        Vue.set(this.proposal, "pendingList", val);
      },
      deep: true,
    },
    pendingFgtsList: {
      handler: function (val) {
        Vue.set(this.proposal, "pendingFgtsList", val);
      },
      deep: true,
    },
    bidderList: {
      handler: function (val) {
        Vue.set(this.proposal, "bidderList", val);
      },
      deep: true,
    },
    proposal: {
      handler: function (val) {
        if (val.pendingList && val.pendingList.length) {
          this.pendingList = val.pendingList;
        } else if (
          !val.pendingList ||
          (val.pendingList && !val.pendingList.length)
        ) {
          Vue.set(this.proposal, "pendingList", this.pendingList);
        }
        if (val.pendingFgtsList && val.pendingFgtsList.length) {
          this.pendingFgtsList = val.pendingFgtsList;
        } else if (!val.pendingFgtsList) {
          Vue.set(this.proposal, "pendingFgtsList", this.pendingFgtsList);
        }
        if (this.proposal.participants && this.proposal.participants.length) {
          this.proposal.participants.forEach((element) => {
            if (!element.participantList) {
              element.participantList = JSON.parse(
                JSON.stringify(this.participantList)
              );
            }
          });
        }
        if (val.bidderList && val.bidderList.length) {
          this.bidderList = val.bidderList;
        } else if (!val.bidderList) {
          Vue.set(this.proposal, "bidderList", this.bidderList);
        }
      },
      immediate: true,
    },
    // 'proposal.issueDate'(newVal) {
    //   console.log(this.proposal.steps.contract, 'this.proposal.steps.contract.situation', newVal);
    //   if(newVal) {
    //     let refernceDate = new Date();
    //     if (this.proposal.steps.contract.situation === 'Emitida' && this.proposal.steps.contract.dueDate) {
    //       refernceDate = moment(this.proposal.steps.contract.dueDate).toDate();
    //     }
    //     const issuedDate = moment(newVal).toDate();
    //     const diff = refernceDate.getTime() - issuedDate.getTime();
    //     const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    //     if(days > 30) {
    //       if (this.proposal.steps.contract.situation === 'Emitida' && this.proposal.steps.contract.dueDate) {
    //         this.$bvToast.toast(
    //           ` Matrícula do imóvel venceu há ${30-days} dias para a data de assinatura da escritura.`,
    //           {
    //             title: "Matrícula do Imóvel",
    //             variant: "danger",
    //             autoHideDelay: 2000,
    //           }
    //         );
    //       } else {
    //         this.$bvToast.toast(
    //           `Solicite a atualização do documento para envio à conformidade.`,
    //           {
    //             title: "Matrícula do Imóvel",
    //             variant: "danger",
    //             autoHideDelay: 2000,
    //           }
    //         );
    //       }
    //     } else if (days > 20 &&  days <= 30) {
    //       if (this.proposal.steps.contract.situation === 'Emitida' && this.proposal.steps.contract.dueDate) {
    //         this.$bvToast.toast(
    //           `Matrícula do imóvel vencerá ${30-days} dias após a assinatura da minuta.`,
    //           {
    //             title: "Matrícula do Imóvel",
    //             variant: "warning",
    //             autoHideDelay: 2000,
    //           }
    //         );
    //       } else {
    //         this.$bvToast.toast(
    //           `Matrícula do imóvel vencerá em ${30-days} dias.`,
    //           {
    //             title: "Matrícula do Imóvel",
    //             variant: "warning",
    //             autoHideDelay: 2000,
    //           }
    //         );
    //       }
    //     }
    //   }
    // }
  },
  filters: {
    getdate(value) {
      let date = new Date(value);
      return (
        date.getDate() +
        "/" +
        date.toLocaleString("default", { month: "2-digit" }) +
        "/" +
        date.getFullYear()
      );
    },
    percent: function (dec) {
      return parseFloat(dec).toFixed(2);
    },
  },
  methods: {
    ...mapActions([
      "getProposal",
      "editProposal",
      "getBankBranches",
      "dismissed",
      "deleteProposal",
      "getTimeLine",
      "getProposalForEdit",
      "getDocuments",
      "getUsers",
      "fetchCommonBuyer",
      "fetchCommonSeller",
      "fetchCommonProperty",
      "fetchProposalBuyer",
      "fetchProposalSeller",
      "fetchProposalProperty",
      "updateProposalShare",
      "setProposalOpen",
    ]),
    ...mapMutations(["setModificationNotification"]),
    getAddressData(addressData, placeResultData) {
      const sublocalityArr = placeResultData.address_components.filter((el) =>
        el.types.includes("sublocality")
      );
      const administrative_area_level_2Arr =
        placeResultData.address_components.filter((el) =>
          el.types.includes("administrative_area_level_2")
        );
      const administrative_area_level_1Arr =
        placeResultData.address_components.filter((el) =>
          el.types.includes("administrative_area_level_1")
        );
      this.proposal.propertyLocation = {
        sublocality:
          sublocalityArr && sublocalityArr.length
            ? sublocalityArr[0].long_name
            : "",
        administrative_area_level_2:
          administrative_area_level_2Arr &&
          administrative_area_level_2Arr.length
            ? administrative_area_level_2Arr[0].long_name
            : "",
        administrative_area_level_1:
          administrative_area_level_1Arr &&
          administrative_area_level_1Arr.length
            ? administrative_area_level_1Arr[0].long_name
            : "",
        country: addressData.country ? addressData.country : "",
        latitude: addressData.latitude ? addressData.latitude : "",
        locality: addressData.locality ? addressData.locality : "",
        longitude: addressData.longitude ? addressData.longitude : "",
        postal_code: addressData.postal_code ? addressData.postal_code : "",
        route: addressData.route ? addressData.route : "",
      };
    },
    bankBranchReminder() {
      if (this.proposal.bankBranch == "") {
        this.$bvToast.toast(
          `Informe de imediato a agência de vincualação da proposta. ;)`,
          {
            title: "Eiiii... Lembrando!",
            variant: "primary",
            autoHideDelay: 2000,
          }
        );
        this.$refs.bankBranch.focus();
        //this.$refs.approvedFinancingAmount.$el.focus();
        //this.$refs.engineeringEvaluation.$el.focus();
        //this.$refs.operationValue.$el.focus();
      }
    },
    issueDateReminder() {
      if (this.proposal.issueDate) {
        let refernceDate = new Date();
        if (
          this.proposal.steps.contract.situation === "Emitida" &&
          this.proposal.steps.contract.dueDate
        ) {
          refernceDate = moment(this.proposal.steps.contract.dueDate).toDate();
        }
        const issuedDate = moment(this.proposal.issueDate).toDate();
        const diff = refernceDate.getTime() - issuedDate.getTime();
        const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
        if (days > 30) {
          if (
            this.proposal.steps.contract.situation === "Emitida" &&
            this.proposal.steps.contract.dueDate
          ) {
            this.$bvToast.toast(
              ` Matrícula do imóvel venceu há ${
                30 - days
              } dias para a data de assinatura da escritura.`,
              {
                title: "Matrícula do Imóvel",
                variant: "danger",
                autoHideDelay: 2000,
              }
            );
            this.showAlertMatricula = true;
            this.showAlertMatriculaMessage = ` Matrícula do imóvel venceu há ${-(
              30 - days
            )} dias para a data de assinatura da escritura.`;
            this.showAlertMatriculaVariant = "danger";
          } else {
            this.$bvToast.toast(
              `Solicite a atualização do documento para envio à conformidade.`,
              {
                title: "Matrícula do Imóvel",
                variant: "danger",
                autoHideDelay: 2000,
              }
            );
            this.showAlertMatricula = true;
            this.showAlertMatriculaMessage = `Solicite a atualização do documento para envio à conformidade.`;
            this.showAlertMatriculaVariant = "danger";
          }
        } else if (days > 20 && days <= 30) {
          if (
            this.proposal.steps.contract.situation === "Emitida" &&
            this.proposal.steps.contract.dueDate
          ) {
            this.$bvToast.toast(
              `Matrícula do imóvel vencerá ${
                30 - days
              } dias após a assinatura da minuta.`,
              {
                title: "Matrícula do Imóvel",
                variant: "warning",
                autoHideDelay: 2000,
              }
            );
            this.showAlertMatricula = true;
            this.showAlertMatriculaMessage = `Matrícula do imóvel vencerá ${
              30 - days
            } dias após a assinatura da minuta.`;
            this.showAlertMatriculaVariant = "success";
          } else {
            this.$bvToast.toast(
              `Matrícula do imóvel vencerá em ${30 - days} dias.`,
              {
                title: "Matrícula do Imóvel",
                variant: "warning",
                autoHideDelay: 2000,
              }
            );
            this.showAlertMatricula = true;
            this.showAlertMatriculaMessage = `Matrícula do imóvel vencerá em ${
              30 - days
            } dias.`;
            this.showAlertMatriculaVariant = "warning";
          }
        }
      }
    },
    definesLowerValueOfTheOperation(proposal) {
      if (proposal.approvedFinancingAmount === 0) {
        return proposal.intendedFinancingValue;
      } else if (
        proposal.intendedFinancingValue <= proposal.approvedFinancingAmount &&
        proposal.operationValue === 0
      ) {
        return proposal.intendedFinancingValue;
      } else if (
        proposal.approvedFinancingAmount <= proposal.intendedFinancingValue &&
        proposal.operationValue === 0
      ) {
        return proposal.approvedFinancingAmount;
      } else {
        return proposal.operationValue;
      }
    },
    confirmDeleteProposal(proposal) {
      var self = this;
      bootbox.confirm({
        centerVertical: true,
        title: "Confirmação de exclução",
        message:
          "A exclusão da proposta de " +
          proposal.name +
          " é irreversível. Deseja continuar?",
        buttons: {
          confirm: {
            label: '<i class="fa fa-check"></i> Sim, excluir!',
            className: "btn-primary",
          },
          cancel: {
            label: '<i class="fa fa-times"></i> Cancelar',
            className: "btn-light",
          },
        },

        callback: function (result) {
          if (result === true) {
            console.log(
              "This was logged in the callback: " + result + " " + proposal.id
            );
            self.deleteProposal(proposal.id);
            router.push({ name: "proposals" });

            //db.collection('proposals').doc(proposal.id).delete()
            //.then(()=>{
            //  console.log('Proposal deleted');
            //  //dispatch('getProposals')
            //})
          } else {
            console.log(
              "This was logged in the callback: " + result + " " + proposal.id
            );
          }
        },
      });
    },
    async viewTimeline(proposal) {
      this.timelineModal = true;
      this.loadingTimeline = true;
      let resp = await this.getTimeLine(proposal);
      this.timelineArray = resp;
      this.loadingTimeline = false;
    },
    openPdfModal(url) {
      this.modalShow = true;
      this.pdfUrl = url;
    },
    openImage(index) {
      this.images = [];
      this.images = this.documentFiles.pngArray[index];
      this.$viewer.show(this.images);
    },
    handleLoading(val) {
      this.isLoading = val;
    },
    async handleUpdateProposal(proposal) {
      if (
        proposal.steps.riskAssessment.status === "Aprovado" &&
        (!proposal.email ||
          (proposal.email && proposal.email === "naodeclarado@cliente.com"))
      ) {
        const vm = this;
        bootbox.confirm({
          title: "Do you want to update proposal ?",
          message:
            "<p>O e-mail do cliente principal não foi definido. Se desejar prosseguir com a atualização da proposta clique em OK e anote nas tarefas para atualizar.</p>",
          centerVertical: true,
          callback: async function (result) {
            try {
              if (result) {
                proposal.noUpdateEmail = true;
                await vm.setNotifications(proposal);
                vm.editProposal(proposal);
              }
            } catch (error) {
              console.log("Error ao adicionar o doc: ", error);
              commit("setError");
              commit("setErrorMessage", {
                color: "danger",
                text: "Opsss...!",
              });
            }
          },
        });
        return;
      }

      await this.setProposalOpen({ id: this.id, val: false });
      await this.setNotifications(proposal);
      await this.editProposal(proposal);
    },
    handleParticipantModal(index) {
      this.selectedParticipant = index;
      this.$bvModal.show(`participantModal-${index}`);
    },
    setNotifications(proposal) {
      // Notifications regarding engineering situation = Boleto
      let formsSituation = proposal.steps.forms.situation;
      let engineeringSituation = proposal.steps.engineering.situation;
      let steps = proposal.steps;
      if (
        engineeringSituation == "Boleto" &&
        engineeringSituation !==
          this.proposalToCheck.steps.engineering.situation
      ) {
        if (
          (proposal.operationModality === "CCFGTS" ||
            proposal.operationModality === "PMCMV" ||
            proposal.operationModality === "PRÓ COTISTA") &&
          /*proposal.operationModality !==
            this.proposalToCheck.operationModality &&*/
          !proposal.steps.forms.actived &&
          !proposal.fgts
        ) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[1],
          });
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[14],
          });
        } else if (!proposal.steps.forms.actived && proposal.fgts) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[0],
          });
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[11],
          });
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[15],
          });
        } else {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[0],
          });
        }

        // Notifications regarding propertyIQ and verifiedSD
        if (proposal.propertyIQ && !proposal.verifiedSD) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[12],
          });
        }
      }

      // Notifications regarding engineering situation = Emitida
      if (
        engineeringSituation == "Emitida" &&
        engineeringSituation !==
          this.proposalToCheck.steps.engineering.situation
      ) {
        this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[17],
          });
      }

      // Notification regarding engineering status =  "Válido"
      if (
        steps.engineering.status == "Válido" &&
        steps.engineering.status !==
          this.proposalToCheck.steps.engineering.status &&
        steps.forms.status == this.proposalToCheck.steps.forms.status
      ) {
        if (proposal.fgts == true && steps.fgts.actived == false) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: proposal.name,
            id: proposal.id,
            text: this.notifications[2],
          });
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[3],
          });
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[4],
          });
        } else {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[3],
          });
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[4],
          });
        }
      }

      // Notification regarding forms status = "Emitidos"
      if (
        formsSituation == "Emitidos" &&
        steps.forms.situation !== this.proposalToCheck.steps.forms.situation
      ) {
        if (proposal.fgts && proposal.steps.fgts.actived == true) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[9],
          });
        } else if (proposal.fgts && proposal.steps.fgts.actived == false) {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[11],
          });
        } else {
          this.setModificationNotification({
            type: "modified",
            created_by: this.user.uid,
            proposalName: this.proposal.name,
            id: this.proposal.id,
            text: this.notifications[7],
          });
        }
      }

      if (
        steps.fgts.actived == true &&
        formsSituation === "Emitidos" &&
        steps.forms.status !== this.proposalToCheck.steps.forms.status
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: proposal.name,
          id: proposal.id,
          text: this.notifications[9],
        });
      }

      // Notification of form step 'À carimbar' || 'Carimbados' & fgts step 'Ressarcida' & contract step `Enviando`
      if (
        steps.forms.status === "À carimbar" &&
        steps.forms.status !== this.proposalToCheck.steps.forms.status
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: proposal.name,
          id: proposal.id,
          text: this.notifications[10],
        });
      } else if (
        steps.forms.status === "Carimbados" &&
        steps.forms.status !== this.proposalToCheck.steps.forms.status
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: proposal.name,
          id: proposal.id,
          text: this.notifications[13],
        });
      }
      if (
        steps.fgts.status === "Ressarcida" &&
        steps.contract.status === "Enviando"
      ) {
        if (
          steps.forms.status !== this.proposalToCheck.steps.forms.status ||
          steps.fgts.status !== this.proposalToCheck.steps.fgts.status ||
          steps.contract.status !== this.proposalToCheck.steps.contract.status
        ) {
          if (steps.forms.status === "À carimbar") {
            this.setModificationNotification({
              type: "modified",
              created_by: this.user.uid,
              proposalName: proposal.name,
              id: proposal.id,
              text: this.notifications[5],
            });
          }

          if (steps.forms.status === "Carimbados") {
            this.setModificationNotification({
              type: "modified",
              created_by: this.user.uid,
              proposalName: proposal.name,
              id: proposal.id,
              text: this.notifications[6],
            });
          }
        }
      }

      // Notification regarding contract status = "Enviando" our "Enviado" => Pedro Acrescentou essa parte
      if (
        (steps.contract.status == "Enviando" ||
          steps.contract.status == "Enviado") &&
        steps.contract.status !== this.proposalToCheck.steps.contract.status
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: proposal.name,
          id: proposal.id,
          text: this.notifications[3],
        });
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: proposal.name,
          id: proposal.id,
          text: this.notifications[16],
        });
      }

      //if (
      //  (steps.contract.status == "Enviando" || steps.contract.status == "Enviado") && steps.engineering.status == "Válido"
      /*steps.contract.status !== this.proposalToCheck.steps.contract.status &&*/

      //) {
      //  this.setModificationNotification({
      //    type: "modified",
      //    created_by: this.user.uid,
      //    proposalName: proposal.name,
      //    id: proposal.id,
      //    text: this.notifications[3],
      //  });
      //}
    },

    async selectOption() {
      this.handleLoading(true);
      if (this.selectedTaskList === "buyer") {
        await this.fetchCommonBuyer();
      }
      if (this.selectedTaskList === "seller") {
        await this.fetchCommonSeller();
      }
      if (this.selectedTaskList === "property") {
        await this.fetchCommonProperty();
      }
      this.setTaskArray();
    },
    async setTaskArray() {
      this.handleLoading(true);
      this.taskListArray = [];
      if (this.selectedTaskList === "buyer") {
        await this.fetchProposalBuyer(this.id);
        this.commonBuyerTask.forEach((commonTask) => {
          this.proposalBuyerTask.forEach((proposalTask) => {
            if (commonTask.id === proposalTask.id) {
              commonTask.value = proposalTask.value;
              if (proposalTask.updateRequired !== "never") {
                commonTask.required = proposalTask.required;
              }
              if (commonTask.subtask && commonTask.subtask.length) {
                commonTask.subtask.forEach((commonSubtask) => {
                  if (proposalTask.subtask && proposalTask.subtask.length) {
                    proposalTask.subtask.forEach((subtask) => {
                      if (commonSubtask.id === subtask.id) {
                        commonSubtask.value = subtask.value;
                        commonSubtask.note = subtask.note;
                      }
                    });
                  }
                  if (commonSubtask.note) {
                    commonSubtask.showNote = true;
                  }
                });
              }
            }
          });
        });
        this.taskListArray = [...this.commonBuyerTask];
      } else if (this.selectedTaskList === "seller") {
        await this.fetchProposalSeller(this.id);
        this.commonSellerTask.forEach((commonTask) => {
          this.proposalSellerTask.forEach((proposalTask) => {
            if (commonTask.id === proposalTask.id) {
              commonTask.value = proposalTask.value;
              if (commonTask.required || proposalTask.required) {
                commonTask.required = true;
              } else {
                commonTask.required = false;
              }
              commonTask.subtask.forEach((commonSubtask) => {
                if (proposalTask.subtask && proposalTask.subtask.length) {
                  proposalTask.subtask.forEach((subtask) => {
                    if (commonSubtask.id === subtask.id) {
                      commonSubtask.value = subtask.value;
                      commonSubtask.note = subtask.note;
                    }
                  });
                }
                if (commonSubtask.note) {
                  commonSubtask.showNote = true;
                }
              });
            }
          });
        });
        this.taskListArray = [...this.commonSellerTask];
      } else if (this.selectedTaskList === "property") {
        await this.fetchProposalProperty(this.id);
        this.commonPropertyTask.forEach((commonTask) => {
          this.proposalPropertyTask.forEach((proposalTask) => {
            if (commonTask.id === proposalTask.id) {
              commonTask.value = proposalTask.value;
              if (commonTask.required || proposalTask.required) {
                commonTask.required = true;
              } else {
                commonTask.required = false;
              }
              commonTask.subtask.forEach((commonSubtask) => {
                if (proposalTask.subtask && proposalTask.subtask.length) {
                  proposalTask.subtask.forEach((subtask) => {
                    if (commonSubtask.id === subtask.id) {
                      commonSubtask.value = subtask.value;
                      commonSubtask.note = subtask.note;
                    }
                  });
                }
                if (commonSubtask.note) {
                  commonSubtask.showNote = true;
                }
              });
            }
          });
        });
        this.taskListArray = [...this.commonPropertyTask];
      }
      this.handleLoading(false);
    },
    handleAddUsers(uid, e) {
      if (e) {
        this.sharedUsers.push(uid);
      } else {
        const index = this.sharedUsers.indexOf(uid);
        this.sharedUsers.splice(index, 1);
      }
    },
    async handleShareProposal() {
      this.isLoading = true;
      const res = await this.updateProposalShare({
        id: this.id,
        users: this.sharedUsers,
      });
      if (res.success) {
        await this.getProposal(this.id);
        this.isLoading = false;
        this.showUserList = false;
      }
    },
    async handleCloseList() {
      this.showUserList = false;
      this.getProposal(this.id);
    },
    async cancelEdit() {
      await this.setProposalOpen({ id: this.id, val: false });
      this.$router.push("/");
    },
  },
  async created() {
    await this.getProposal(this.id);
    await this.getBankBranches();
    await this.getProposalForEdit(this.id);
    await this.getDocuments(this.id);
    // await this.getCommonBuyerTask();
    // await this.getCommonSellerTask();
    // await this.getCommonPropertyTask();
    // await this.getPropertyFromAnywhere(this.id)
    // await this.addquestion(this.abc)
    // await this.$store.commit('setProposalToEdit', JSON.parse(JSON.stringify(this.proposal)))

    await this.$store.commit(
      "setProposalToCheck",
      JSON.parse(JSON.stringify(this.proposal))
    );
    this.selectOption();
    this.bankBranchReminder();
    this.getUsers();
    this.issueDateReminder();
  },
  computed: {
    ...mapState([
      "proposal",
      "preloader",
      "optionsBankBranch",
      "optionsShippingMode",
      "optionsMaritalStatus",
      "optionsPropertyType",
      "optionsPropertyCategory",
      "optionsAmortizationSystem",
      "optionsIndexer",
      "optionsOperationModality",
      "bankBranches",
      "error",
      "errorMessage",
      "dismissCountDown",
      "documentFiles",
      "commonBuyerTask",
      "commonSellerTask",
      "commonPropertyTask",
      "proposalBuyerTask",
      "proposalSellerTask",
      "proposalPropertyTask",
      "users",
      "user",
      "proposalToCheck",
    ]),

    ...mapState("Notification", ["notifications"]),

    locationData: {
      get: function () {
        if (this.proposal.propertyLocation) {
          const location =
            this.proposal.propertyLocation.locality &&
            this.proposal.propertyLocation.route &&
            this.proposal.propertyLocation.sublocality
              ? `${this.proposal.propertyLocation.route} - ${this.proposal.propertyLocation.sublocality},${this.proposal.propertyLocation.locality}`
              : this.proposal.propertyLocation.route &&
                this.proposal.propertyLocation.sublocality
              ? `${this.proposal.propertyLocation.route} - ${this.proposal.propertyLocation.sublocality}`
              : this.proposal.propertyLocation.route
              ? `${this.proposal.propertyLocation.route}`
              : this.proposal.propertyLocation.locality
              ? `${this.proposal.propertyLocation.locality}`
              : `${this.proposal.propertyLocation.sublocality}`;
          if (
            this.proposal.propertyLocation.administrative_area_level_2 ===
            this.proposal.propertyLocation.administrative_area_level_1
          ) {
            return `${location},${this.proposal.propertyLocation.administrative_area_level_2} - State of ${this.proposal.propertyLocation.administrative_area_level_1}, ${this.proposal.propertyLocation.country}`;
          } else if (
            this.proposal.propertyLocation.administrative_area_level_2 ===
            this.proposal.propertyLocation.locality
          ) {
            return `${location},${this.proposal.propertyLocation.administrative_area_level_1}, ${this.proposal.propertyLocation.country}`;
          } else {
            return `${location},${this.proposal.propertyLocation.administrative_area_level_2}-${this.proposal.propertyLocation.administrative_area_level_1}, ${this.proposal.propertyLocation.country}`;
          }
        } else {
          return "";
        }
      },
      set: function (newValue) {
        if (this.propertyLocation.location) {
          const location = newValue.locality
            ? `${newValue.locality}, ${newValue.administrative_area_level_1}, ${newValue.country}`
            : newValue.route
            ? `${newValue.route},${newValue.administrative_area_level_1}, ${newValue.country}`
            : `${newValue.administrative_area_level_1}, ${newValue.country}`;
          return location;
        } else {
          return "";
        }
      },
    },
    defineBadgeColorOfRiskAssessment() {
      return this.options[1].value[this.proposal.steps.riskAssessment.status];
    },
    getDateCreated() {
      let createdDate = "";
      if (this.proposal && this.proposal.created) {
        createdDate = this.proposal.created.toDate();
        return moment(createdDate).locale("pt-BR").format("L [às] LTS");
      }
    },
    getDateUpdated() {
      if (this.proposal && this.proposal.updated) {
        var updatedDate = this.proposal.updated.toDate();
        return moment(updatedDate).locale("pt-BR").format("L [às] LTS");
      }
    },

    usersList() {
      let users = [];
      if (this.searchUser) {
        users = this.users.filter(
          (el) =>
            el.email !== this.proposal.created_by &&
            el.name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1
        );
      } else {
        users = this.users.filter(
          (el) => el.email !== this.proposal.created_by
        );
      }
      users.forEach((user) => {
        if (this.sharedUsers && this.sharedUsers.includes(user.uid)) {
          user.shared = true;
        } else {
          user.shared = false;
        }
      });
      return users;
    },
    sharedUsersList() {
      if (this.proposal && this.proposal.shareWith) {
        return this.users.filter((el) =>
          this.proposal.shareWith.includes(el.id)
        );
      }
      return [];
    },
    issueDateExpired() {
      const today = new Date();
      const issuedDate = moment(this.proposal.issueDate).toDate();
      const diff = today.getTime() - issuedDate.getTime();
      const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
      if (days > 30) {
        return "Vencido";
      } else {
        return "Válido";
      }
    },
  },
  directives: {
    mask,
    // currency: CurrencyDirective
  },
  async beforeDestroy() {
    await this.setProposalOpen({ id: this.id, val: false });
  },
};
</script>
<style>
.pac-container {
  z-index: 10000 !important;
}
</style>
<style scoped>
i.fas.fa-pen,
i.fa.fa-trash-alt,
i.fa.fa-history,
i.fas.fa-tasks,
i.fas.fa-download,
i.fas.fa-print,
i.fas.fa-upload,
i.fas.fa-share-alt {
  color: #6c757d;
  padding: 0.5em;
  border-radius: 50%;
}

i.fas.fa-pen:hover,
i.fa.fa-trash-alt:hover,
i.fa.fa-history:hover,
i.fas.fa-tasks:hover,
i.fas.fa-download:hover,
i.fas.fa-print:hover,
i.fas.fa-upload:hover,
i.fas.fa-share-alt:hover {
  color: #000000;
  padding: 0.5em;
  border-radius: 50%;
  background-color: #e3e7eb;
}
.documentImages {
  width: 100px;
  height: 100px;
}
>>> #largeDialog .modal-xl {
  margin: 0 auto;
  height: 100vh;
}
>>> #largeDialog .modal-body {
  padding: 0;
  height: 100vh;
}
.incompletedList {
  max-height: 38vh;
  overflow: auto;
}
>>> .card-body {
  /*height: calc(100vh - 190px);*/
  /*padding: 0px 10px;*/
  overflow: auto;
}
>>> .b-sidebar > .b-sidebar-header {
  font-size: 1.2rem;
  font-weight: 100;
}
>>> .list-group-item {
  background-color: transparent;
  border-bottom: 1px solid #ccc;
  border: none;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
}

/*>>> .list-group-item .col-2, .list-group-item .col-8 {
  padding: 0;
}*/

.userListWrapper {
  position: relative;
}
.userList {
  position: absolute;
  z-index: 999;
  width: 500px;
}
.userListHead {
  padding: 6px;
  border-bottom: 1px solid #c7c7c7;
}
.userListBody {
  height: 60vh;
  overflow: auto;
}
.userListItem {
  padding: 6px;
  /*border-bottom: 1px solid #c7c7c7;*/
}
.userListItemLabel {
  font-size: 14px;
  text-transform: "capitalze";
}
.userListFooter {
  border-top: 1px solid #c7c7c7;
}
.searchWrapper {
  width: 300px;
}
.pendingText {
  font-size: 14px;
}
.dotIcon {
  font-size: 10px;
}
.alertIcon {
  font-size: 22px;
}
</style>
